import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import { FormattedMessage, injectIntl } from 'react-intl'

import {
  selectSection,
  selectIndex,
  updateText,
} from '../actions/DetailedFeedback'
import {
  detailedFeedbackUpdated,
  redirectSelect,
  updateFeedbackState,
} from '../actions/AspireFeedback'
import { updateImageData } from '../actions/ImageUpload'
import DetailedFeedbackComponent from '../components/DetailedFeedback'
import sections from '../config/sections'
import $ from 'jquery'
import _ from 'underscore'
import 'jquery-highlight'
import { updateEditedDataState } from '../actions/Edit'
import { sendTrackingData } from '@vmockinc/dashboard/services/tracking'
import { sectionUnderscore } from '../components/Constants/UniversalMapping'
import { fetchCustomisation, getNestedValue } from '../services/helpers'
import {
  wrapHeadline,
  wrapText,
  convertDomToString,
  cleanWord,
  getSectionScore,
  lowerScore,
  SECTION_TO_HIGHLIGHT_ENTITIES_MAP,
} from '../services/detailed_feedback'
import ProductNavigation from '@vmockinc/dashboard/Common/commonComps/ProductNavigation/index'

let timerStarted = false
let showNavigationPopup = false

const reverseSectionCamelCase = {
  '#personal_information': 'Personal Information',
  '#profile_picture': 'Profile Picture',
  '#headline': 'Headline',
  '#summary': 'Summary',
  '#experience': 'Experience',
  '#education': 'Education',
  '#overall': 'Overall',
}

class DetailedFeedback extends Component {
  constructor(props) {
    super(props)
    this.onSelectSection = this.onSelectSection.bind(this)
    this.onSelectPrev = this.onSelectPrev.bind(this)
    this.onSelectNext = this.onSelectNext.bind(this)
    this.onSelectIndex = this.onSelectIndex.bind(this)
    this.onUpdateText = this.onUpdateText.bind(this)
    this.highlightEntityText = this.highlightEntityText.bind(this)
    this.unhighlightAll = this.unhighlightAll.bind(this)
    this.unhighlightAllEdit = this.unhighlightAllEdit.bind(this)
    this.resetSectionNavs = this.resetSectionNavs.bind(this)
    this.underlineSpellError = this.underlineSpellError.bind(this)
    this.editSectionUpdated = this.editSectionUpdated.bind(this)
    this.changeNewSubSectionValue = this.changeNewSubSectionValue.bind(this)
    this.changeModalState = this.changeModalState.bind(this)
    this.setSelectedPanelPersonalInfo =
      this.setSelectedPanelPersonalInfo.bind(this)

    this.spellErrors = []
    this.derivedSkills = {}
    this.targetFunctionBackToFrontEndMapping = this.props.functions['mapping']
    this.profileData = this.fetchProfileData(this.props.feedback)
    this.logModalMounted = false
    this.editModalMounted = false

    this.state = {
      highlightableDivWords: [],
      highlightableEditDivWords: [],
      highlightableDivIds: [],
      highlightedSection: '',
      activeNavIndex: 0,
      newSubSection: false,
      selectedPanelPersonalInfo: 'name',
    }
    this.updateEditSection = false
    this.sendTrackingDataDebounce = _.debounce(sendTrackingData, 2000, true)
    this.sendTrackingDataDebouncePrevBtn = _.debounce(
      sendTrackingData,
      500,
      true
    )
    this.sendTrackingDataDebounceNextBtn = _.debounce(
      sendTrackingData,
      500,
      true
    )
    this._isMounted = true
    this.highlightableEditDivWords = []
  }

  setSelectedPanelPersonalInfo(panelName) {
    this.setState({ selectedPanelPersonalInfo: panelName })
  }

  UNSAFE_componentWillMount() {
    const {
      updateText,
      redirectSelect,
      selectSection,
      match: { params },
    } = this.props

    updateText({
      updateKeys: [
        ['totalScore'],
        ['totalScoreColor'],
        ['resumeSkillsInLinkedin'],
        ['resumeSkillsNotInLinkedin'],
        ['suggestedSkills'],
        ['newSectionSuggestedSkills'],
        ['derivedSkills'],
        ['sections'],
        ['sectionsPerSkill'],
        ['sectionWiseText'],
        ['sectionWiseTextPdf'],
        ['sectionWiseTextEditable'],
        ['sectionWiseTextStatic'],
        ['sectionsEntitiesToHighlight'],
        ['logs'],
      ],
      data: this.profileData,
    })

    if (!_.isEmpty(this.props.location.hash)) {
      let key = reverseSectionCamelCase[this.props.location.hash]
      if (!_.isUndefined(key)) {
        selectSection(key)
      } else {
        selectSection('Overall')
        // redirectSelect(params.fetchId, 'detailed', 'Personal Information')
      }
    } else {
      selectSection('Overall')
      // redirectSelect(params.fetchId, 'detailed', 'Personal Information')
    }

    if (this.props.callOnSelectSectionDependenciesInDetailedFeedback == true) {
      this.unhighlightAll()
      this.resetSectionNavs(0)
      this.props.selectSection(this.props.keyForSelectSection)
      this.props.updateFeedbackState({
        updateKeys: [
          ['callOnSelectSectionDependenciesInDetailedFeedback'],
          ['keyForSelectSection'],
        ],
        data: {
          callOnSelectSectionDependenciesInDetailedFeedback: false,
          keyForSelectSection: '',
        },
      })

      const {
        update_detailed_state,
        ui,
        feedback,
        editedSection,
        editedSubSectionId,
        editedIsNewSubSection,
        editedSectionDeleted,
      } = this.props

      if (update_detailed_state == true) {
        const { detailedFeedbackUpdated, updateText } = this.props
        this.profileData = this.fetchProfileData(this.props.feedback)
        let { section, sectionWiseText } = ui
        let { edited_section_mapping } = feedback
        let currentIndex = ui[section]['currentIndex']
        this.profileData[section] = {}
        this.profileData['section'] = section
        this.profileData[section]['currentIndex'] = ui[section]['currentIndex']
        if (
          !_.isEmpty(edited_section_mapping) &&
          !_.isEmpty(editedSection) &&
          _.size(edited_section_mapping) > 1 &&
          section == editedSection
        ) {
          if (editedIsNewSubSection == true) {
            // size > 1, so other sub_sections already exist
            if (this.state.newSubSection == true) {
              // Edit Modal is open to new section (section name_new)
              for (var i in edited_section_mapping) {
                if (edited_section_mapping[i]['is_new_sub_section'] == true) {
                  this.profileData[section]['currentIndex'] =
                    edited_section_mapping[i]['new_sub_section_id']
                  break
                }
              }
            } else {
              for (var i in edited_section_mapping) {
                if (
                  currentIndex ==
                  edited_section_mapping[i]['old_sub_section_id']
                ) {
                  this.profileData[section]['currentIndex'] =
                    edited_section_mapping[i]['new_sub_section_id']
                  break
                }
              }
            }
          } else if (
            editedSectionDeleted != true &&
            !_.isString(editedSubSectionId)
          ) {
            for (var i in edited_section_mapping) {
              if (
                edited_section_mapping[i]['new_sub_section_id'] !== -1 &&
                currentIndex == edited_section_mapping[i]['old_sub_section_id']
              ) {
                this.profileData[section]['currentIndex'] =
                  edited_section_mapping[i]['new_sub_section_id']
                break
              }
            }
          }
        }

        // re-assign currentIndex for deleted section
        if (
          !_.isEmpty(edited_section_mapping) &&
          !_.isEmpty(editedSection) &&
          editedSectionDeleted == true &&
          section == editedSection
        ) {
          if (
            edited_section_mapping.length === 1 &&
            currentIndex === edited_section_mapping[0]['old_sub_section_id']
          ) {
            this.profileData['section'] = section
          }
          this.profileData[section]['currentIndex'] = 0
        }

        updateText({
          updateKeys: [
            ['section'],
            [section, 'currentIndex'],
            ['totalScore'],
            ['totalScoreColor'],
            ['resumeSkillsInLinkedin'],
            ['resumeSkillsNotInLinkedin'],
            ['suggestedSkills'],
            ['newSectionSuggestedSkills'],
            ['derivedSkills'],
            ['sections'],
            ['sectionsPerSkill'],
            ['sectionWiseText'],
            ['sectionWiseTextPdf'],
            ['sectionWiseTextEditable'],
            ['sectionWiseTextStatic'],
            ['sectionsEntitiesToHighlight'],
            ['logs'],
          ],
          data: this.profileData,
        })

        this.props.updateEditedDataState({
          updateKeys: [['new_sub_section'], ['delete_sub_section']],
          data: { new_sub_section: false, delete_sub_section: false },
        })
        detailedFeedbackUpdated()

        this.props.selectSection(section)
        redirectSelect(params.fetchId, 'detailed', section)
        this.updateEditSection = true
      }
    }
  }

  componentDidMount() {
    this.unhighlightAll()
    this.hashLinkScroll()
    if (!timerStarted) {
      timerStarted = true
      setTimeout(() => {
        showNavigationPopup = true
        if (this._isMounted) {
          this.forceUpdate()
        }
      }, 1000)
    }
  }

  componentWillUnmount() {
    this._isMounted = false
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      update_detailed_state,
      ui,
      feedback,
      editedSection,
      editedSubSectionId,
      editedIsNewSubSection,
      editedSectionDeleted,
      imageData,
      redirectSelect,
      match: { params },
      isGenAiFeedback,
    } = this.props
    if (imageData.update_store == true) {
      const { updateImageData, updateText } = this.props
      // Update store
      this.profileData = this.fetchProfileData(this.props.feedback)
      updateText({
        updateKeys: [['sectionWiseTextEditable']],
        data: this.profileData,
      })
      if (imageData.edit_picture_mounted == false) {
        updateImageData({
          updateKeys: [['uploaded_image'], ['update_store']],
          data: { uploaded_image: false, update_store: false },
        })
      } else {
        updateImageData({
          updateKeys: [['update_store']],
          data: { update_store: false },
        })
      }
    }

    if (imageData.refresh_url == true) {
      const { updateImageData, updateText } = this.props

      // Update store
      this.profileData = this.fetchProfileData(this.props.feedback)
      if (
        this.profileData['sectionWiseTextStatic'][
          'profile_picture'
        ].hasOwnProperty('0')
      ) {
        let tmp = {
          sectionWiseTextEditable: {
            profile_picture: { 0: { picture_url: imageData.url } },
          },
          sectionWiseTextStatic: {
            profile_picture: { 0: { picture_url: imageData.url } },
          },
        }
        updateText({
          updateKeys: [
            ['sectionWiseTextEditable', 'profile_picture', '0', 'picture_url'],
            ['sectionWiseTextStatic', 'profile_picture', '0', 'picture_url'],
          ],
          data: tmp,
        })
      }

      if (imageData.edit_picture_mounted == false) {
        updateImageData({
          updateKeys: [['uploaded_image'], ['refresh_url']],
          data: { uploaded_image: false, refresh_url: false },
        })
      } else {
        updateImageData({
          updateKeys: [['refresh_url']],
          data: { refresh_url: false },
        })
      }
    }

    if (update_detailed_state == true) {
      const { detailedFeedbackUpdated, updateText } = this.props
      this.profileData = this.fetchProfileData(this.props.feedback)
      let { section, sectionWiseText } = ui
      let { edited_section_mapping } = feedback
      let currentIndex = ui[section]['currentIndex']
      this.profileData[section] = {}
      this.profileData['section'] = section
      this.profileData[section]['currentIndex'] = ui[section]['currentIndex']
      if (
        !_.isEmpty(edited_section_mapping) &&
        !_.isEmpty(editedSection) &&
        _.size(edited_section_mapping) > 1 &&
        section == editedSection
      ) {
        if (editedIsNewSubSection == true) {
          // size > 1, so other sub_sections already exist
          if (this.state.newSubSection == true) {
            // Edit Modal is open to new section (section name_new)
            for (var i in edited_section_mapping) {
              if (edited_section_mapping[i]['is_new_sub_section'] == true) {
                this.profileData[section]['currentIndex'] =
                  edited_section_mapping[i]['new_sub_section_id']
                break
              }
            }
          } else {
            for (var i in edited_section_mapping) {
              if (
                currentIndex == edited_section_mapping[i]['old_sub_section_id']
              ) {
                this.profileData[section]['currentIndex'] =
                  edited_section_mapping[i]['new_sub_section_id']
                break
              }
            }
          }
        } else if (
          editedSectionDeleted != true &&
          !_.isString(editedSubSectionId)
        ) {
          for (var i in edited_section_mapping) {
            if (
              edited_section_mapping[i]['new_sub_section_id'] !== -1 &&
              currentIndex == edited_section_mapping[i]['old_sub_section_id']
            ) {
              this.profileData[section]['currentIndex'] =
                edited_section_mapping[i]['new_sub_section_id']
              break
            }
          }
        }
      }

      // re-assign currentIndex for deleted section
      if (
        !_.isEmpty(edited_section_mapping) &&
        !_.isEmpty(editedSection) &&
        editedSectionDeleted == true &&
        section == editedSection
      ) {
        if (
          edited_section_mapping.length === 1 &&
          currentIndex === edited_section_mapping[0]['old_sub_section_id']
        ) {
          this.profileData['section'] = section
        }
        this.profileData[section]['currentIndex'] = 0
      }

      updateText({
        updateKeys: [
          ['section'],
          [section, 'currentIndex'],
          ['totalScore'],
          ['totalScoreColor'],
          ['resumeSkillsInLinkedin'],
          ['resumeSkillsNotInLinkedin'],
          ['suggestedSkills'],
          ['newSectionSuggestedSkills'],
          ['derivedSkills'],
          ['sections'],
          ['sectionsPerSkill'],
          ['sectionWiseText'],
          ['sectionWiseTextPdf'],
          ['sectionWiseTextEditable'],
          ['sectionWiseTextStatic'],
          ['sectionsEntitiesToHighlight'],
          ['logs'],
        ],
        data: this.profileData,
      })

      this.props.updateEditedDataState({
        updateKeys: [['new_sub_section'], ['delete_sub_section']],
        data: { new_sub_section: false, delete_sub_section: false },
      })
      detailedFeedbackUpdated()

      this.props.selectSection(section)

      redirectSelect(params.fetchId, 'detailed', section)

      this.updateEditSection = true
    } else {
      for (var i in this.state.highlightableDivWords) {
        if (this.state.highlightableDivWords[i][2] == 'highlight') {
          $(this.state.highlightableDivWords[i][0]).highlight(
            this.state.highlightableDivWords[i][1],
            { wordsOnly: true }
          )
          $(this.state.highlightableDivWords[i][0]).attr('tabindex', 11)
        } else if (this.state.highlightableDivWords[i][2] == 'highlight-red'
            || this.state.highlightableDivWords[i][2] == 'highlight-green'
        ) {
          if(isGenAiFeedback) {
            function getAllTextNodes(root) {
              const nodes = [];
              function recurse(node) {
                if (node.nodeType === Node.TEXT_NODE) {
                  nodes.push(node);
                } else {
                  for (let child of node.childNodes) recurse(child);
                }
              }
              recurse(root);
              return nodes;
            }

            function highlightPhrase(container, textNodes, fullText, phrase, className = 'highlight-red') {
              const start = fullText.indexOf(phrase);
              if (start === -1) return null;
              let remaining = phrase.length;
              let globalIdx = 0;
              const highlights = [];
              let phraseIdx = 0;
              for (const node of textNodes) {
                if (phraseIdx >= phrase.length) break;
                const nodeText = node.textContent;
                const nodeStart = globalIdx;
                const nodeEnd = nodeStart + nodeText.length;
                const overlapStart = Math.max(start, nodeStart);
                const overlapEnd = Math.min(start + phrase.length, nodeEnd);
                if (overlapStart < overlapEnd) {
                  const localStart = overlapStart - nodeStart;
                  const localEnd = overlapEnd - nodeStart;
                  highlights.push({ node, localStart, localEnd });
                  phraseIdx += (localEnd - localStart);
                }
                globalIdx += nodeText.length;
              }
              const restoreOps = [];
              highlights.slice().reverse().forEach(({ node, localStart, localEnd }) => {
                let alreadyHighlighted = false;
                let curr = node;
                while (curr) {
                  if (
                    curr.nodeType === Node.ELEMENT_NODE &&
                    curr.tagName === 'MARK' &&
                    curr.classList.contains(className)
                  ) {
                    alreadyHighlighted = true;
                    break;
                  }
                  curr = curr.parentNode;
                }
                if (!alreadyHighlighted) {
                  const original = node.textContent;
                  const before = original.slice(0, localStart);
                  const target = original.slice(localStart, localEnd);
                  const after = original.slice(localEnd);

                  const mark = document.createElement('mark');
                  mark.className = className;
                  mark.textContent = target;
                  const parent = node.parentNode;
                  const frag = document.createDocumentFragment();
                  if (before) frag.appendChild(document.createTextNode(before));
                  frag.appendChild(mark);
                  if (after) frag.appendChild(document.createTextNode(after));
                  if (!parent) return;
                  parent.replaceChild(frag, node);
                  restoreOps.push(() => {
                    const siblings = Array.from(parent.childNodes);
                    let idx = siblings.findIndex(n => n === mark);
                    let left = (idx > 0 && siblings[idx-1].nodeType === Node.TEXT_NODE) ? siblings[idx-1] : null;
                    let right = (idx < siblings.length-1 && siblings[idx+1].nodeType === Node.TEXT_NODE) ? siblings[idx+1] : null;
                    const restored = [
                      left ? left.textContent : '',
                      mark.textContent,
                      right ? right.textContent : ''
                    ].join('');
                    const restoredNode = document.createTextNode(restored);
                    if (right) parent.removeChild(right);
                    parent.replaceChild(restoredNode, mark);
                    if (left) parent.removeChild(left);
                  });
                }
              });
              return () => {
                restoreOps.forEach(fn => fn());
              };
            }
            const groupedBySelector = {};
            this.state.highlightableDivWords.forEach(([selector, highlightText, highlightClass]) => {
              if (!groupedBySelector[selector]) {
                groupedBySelector[selector] = [];
              }
              groupedBySelector[selector].push({ text: highlightText, className: highlightClass || 'highlight-red' });
            });

            function getBaseClassFromSelector(selector) {
              const match = selector.match(/\.[\w-]+/);
              return match ? match[0] : null;
            }

            Object.entries(groupedBySelector).forEach(([selector, highlights]) => {
              const baseClass = getBaseClassFromSelector(selector);
              const containers = document.querySelectorAll(baseClass);
              containers.forEach(container => {
                const textNodes = getAllTextNodes(container);
                const fullText = textNodes.map(n => n.textContent).join('');
                highlights.forEach(({ text: phrase, className }) => {
                  highlightPhrase(container, textNodes, fullText, phrase, className);
                });
              });
            });

          }
          else {
            $(this.state.highlightableDivWords[i][0]).highlight(
              this.state.highlightableDivWords[i][1],
              { className: 'highlight-red', wordsOnly: true }
            )
            $(this.state.highlightableDivWords[i][0]).attr('tabindex', 11)
          }

        } else if (this.state.highlightableDivWords[i][2] == 'addClass') {
          $(this.state.highlightableDivWords[i][0]).addClass('highlight')
          $(this.state.highlightableDivWords[i][0]).attr('tabindex', 11)
        } else if (this.state.highlightableDivWords[i][2] == 'addClass-red') {
          $(this.state.highlightableDivWords[i][0]).addClass('highlight-red')
          $(this.state.highlightableDivWords[i][0]).attr('tabindex', 11)
        }
        $(this.state.highlightableDivWords[i][0]).attr('role', 'menubar')
      }

      for (var i in this.state.highlightableDivIds) {
        $(this.state.highlightableDivIds[i][0]).addClass(
          this.state.highlightableDivIds[i][1]
        )
        $(this.state.highlightableDivIds[i][0]).attr('tabindex', 11)
      }
    }
    if (this.props.isEditModal) {
      let highlightableEditDivWords = this.state.highlightableEditDivWords
      for (let i in highlightableEditDivWords) {
        $(highlightableEditDivWords[i][0]).highlight(
          highlightableEditDivWords[i][1],
          {
            wordsOnly: true,
            wordsBoundaryStart: '(?:[\\b\\W]|^)',
            wordsBoundaryEnd: '(?:[\\b\\W]|$)',
          }
        )
      }
    }
    // if (this.props.location.hash !== prevProps.location.hash) {
    //   this.hashLinkScroll()
    // }
  }

  hashLinkScroll() {
    const { hash } = window.location
    if (hash !== '') {
      // Push onto callback queue so it runs after the DOM is updated,
      // this is required when navigating from a different page so that
      // the element is rendered on the page before trying to getElementById.
      setTimeout(() => {
        let id = hash.replace('#', '')
        if (id == 'profile_picture' || hash === '#overall') {
          id = 'profile_picture_linkedin'
        }
        const element = document.getElementById(id)
        if (id == 'profile_picture' || hash === '#overall') {
          element.scrollIntoView({ behavior: 'smooth', block: 'start' })
        } else {
          element.scrollIntoView({ behavior: 'smooth', block: 'center' })
        }
      }, 0)
    }
  }

  onSelectSection(e, type, sectionKey = null) {
    const {
      selectSection,
      redirectSelect,
      ui,
      markSectionVisited,
      match: { params },
      selectIndex,
      feedback,
    } = this.props
    let key = ''
    if (!_.isNull(sectionKey)) {
      key = sectionKey
    } else {
      key = _.isUndefined(e.currentTarget.dataset['key'])
        ? 'Personal Information'
        : e.currentTarget.dataset['key']
    }
    this.unhighlightAll()
    this.unhighlightAllEdit()
    this.resetSectionNavs(0)
    selectSection(key)
    if (key === 'Education' || key === 'Experience') {
      if (
        (key === 'Education' &&
          feedback['section_wise_feedback']['education_feedback'][
            'number_of_education'
          ] === 1) ||
        (key === 'Experience' &&
          feedback['section_wise_feedback']['experience_feedback'][
            'number_of_experiences'
          ]['count'] === 1)
      ) {
        selectIndex(0)
      } else {
        selectIndex(null)
      }
    } else {
      selectIndex(0)
    }
    let jsonObjectForTracking = {
      eventLabel: 'section_select',
      sectionName: key,
      currentIndex: ui[key]['currentIndex'],
      type: type,
    }

    this.sendTrackingDataDebounce(
      'event',
      'aspire_detailed_feedback_screen',
      'click',
      JSON.stringify(jsonObjectForTracking)
    )
    redirectSelect(params.fetchId, 'detailed', key)
  }

  resetSectionNavs(i = 0) {
    this.setState({ activeNavIndex: i })
  }

  onSelectPrev(index, sectionName, currentSection) {
    if (sectionName !== currentSection) {
      return
    }

    const { selectIndex, updateText, isEditModal } = this.props

    if (index > 0) {
      let jsonObjectForTracking = {
        eventLabel: 'prev_section_btn',
        sectionName: sectionName,
        subSectionId: index,
      }
      this.sendTrackingDataDebouncePrevBtn(
        'event',
        'aspire_detailed_feedback_screen',
        'click',
        JSON.stringify(jsonObjectForTracking)
      )

      index = index - 1
    } else {
      let jsonObjectForTracking = {
        eventLabel: 'disabled_prev_section_btn',
        sectionName: sectionName,
        subSectionId: index,
      }
      this.sendTrackingDataDebouncePrevBtn(
        'event',
        'aspire_detailed_feedback_screen',
        'click',
        JSON.stringify(jsonObjectForTracking)
      )
    }

    this.unhighlightAll()
    this.unhighlightAllEdit()
    selectIndex(index)
    if (isEditModal) {
      updateText({
        updateKeys: [['currentEditSectionIndex']],
        data: {
          currentEditSectionIndex: index,
        },
      })
    }
  }

  onSelectNext(index, len, sectionName, currentSection) {
    if (sectionName !== currentSection) {
      return
    }

    const { selectIndex, updateText, isEditModal } = this.props

    if (index < len - 1) {
      let jsonObjectForTracking = {
        eventLabel: 'next_section_btn',
        sectionName: sectionName,
        subSectionId: index,
      }
      this.sendTrackingDataDebounceNextBtn(
        'event',
        'aspire_detailed_feedback_screen',
        'click',
        JSON.stringify(jsonObjectForTracking)
      )

      index = index + 1
    } else {
      let jsonObjectForTracking = {
        eventLabel: 'disabled_next_section_btn',
        sectionName: sectionName,
        subSectionId: index,
      }
      this.sendTrackingDataDebounceNextBtn(
        'event',
        'aspire_detailed_feedback_screen',
        'click',
        JSON.stringify(jsonObjectForTracking)
      )
    }

    this.unhighlightAll()
    this.unhighlightAllEdit()
    selectIndex(index)
    if (isEditModal) {
      updateText({
        updateKeys: [['currentEditSectionIndex']],
        data: {
          currentEditSectionIndex: index,
        },
      })
    }
  }

  onSelectIndex(index, len, sectionName, currentSection) {
    const { selectIndex } = this.props

    if (index > len - 1 || index < 0) {
      return
    } else {
      let jsonObjectForTracking = {
        eventLabel: 'sub_section_select',
        sectionName: sectionName,
        subSectionId: index,
      }
      this.sendTrackingDataDebounceNextBtn(
        'event',
        'aspire_detailed_feedback_screen',
        'click',
        JSON.stringify(jsonObjectForTracking)
      )
    }

    this.unhighlightAll()
    this.unhighlightAllEdit()
    selectIndex(index)
  }

  underlineSpellError() {
    for (let i in this.spellErrors) {
      $(this.spellErrors[i][0]).highlight(this.spellErrors[i][1], {
        className: 'underline-spell-error',
        wordsOnly: true,
        wordsBoundaryStart: '(?:[\\b\\W]|^)',
        wordsBoundaryEnd: '(?:[\\b\\W]|$)',
      })
    }
  }

  changeNewSubSectionValue(value) {
    this.setState({ newSubSection: value })
  }

  editSectionUpdated() {
    this.updateEditSection = false
  }

  changeModalState(component, bool) {
    if (component == 'edit') {
      this.editModalMounted = bool
    } else if (component == 'log') {
      this.logModalMounted = bool
    }
  }

  unhighlightAll() {
    $('.highlightable .highlight-red').unhighlight({
      className: 'highlight-red',
    })
    $('.highlightable .highlight').unhighlight()
    $('.highlightable.highlight-red').unhighlight({
      className: 'highlight-red',
    })
    $('.highlightable.highlight').unhighlight()
    $('.highlight').attr('tabindex', -1)
    $('.highlight-div').attr('tabindex', -1)
    $('.highlight-red').attr('tabindex', -1)
    $('.highlight').removeClass('highlight')
    $('.highlight').removeAttr('role')
    $('.highlight-red').removeClass('highlight-red')
    $('.highlight-div').removeClass('highlight-div')
    $('.highlight').removeAttr('role')
    this.setState({ highlightableDivWords: [], highlightableDivIds: [] })

    const { updateText } = this.props
    let tempData = Object.assign({}, this.profileData)
    let prevSection = this.state.highlightedSection
    if (prevSection == 'Headline') {
      tempData['sectionWiseText'][sectionUnderscore[prevSection]] =
        wrapHeadline(
          this.props.feedback['section_wise_feedback']['headline_feedback'][
            'text_array'
          ],
          {}
        )
      updateText({
        updateKeys: [['sectionWiseText', sectionUnderscore[prevSection]]],
        data: tempData,
      })
    } else if (
      prevSection == 'Summary' ||
      prevSection == 'Experience' ||
      prevSection == 'Education'
    ) {
      tempData['sectionWiseText'][sectionUnderscore[prevSection]] = wrapText(
        this.props.feedback['section_wise_feedback'],
        sectionUnderscore[prevSection] + '_feedback',
        {}
      )
      updateText({
        updateKeys: [['sectionWiseText', sectionUnderscore[prevSection]]],
        data: tempData,
      })
    }
  }

  unhighlightAllEdit() {
    for (let i in this.state.highlightableEditDivWords) {
      $(this.state.highlightableEditDivWords[i][0]).unhighlight()
    }
    this.setState({ highlightableEditDivWords: [] })
    this.highlightableEditDivWords = []
  }

  onUpdateText(obj, flag, currentSection, highlightClass = '') {
    const { isGenAiFeedback } = this.props;
    this.unhighlightAll()
    const { updateText } = this.props
    this.setState({ highlightableDivWords: [], highlightableDivIds: [] })
    if (flag == 1) {
      // word
      var highlightableDivWords = []
      for (var divId in obj) {
        for (var i in obj[divId]) {
          if (highlightClass == '') {
            highlightableDivWords.push([
              `.div-id-${divId}`,
              obj[divId][i]['word'],
              'highlight',
            ])
          } else {
            highlightableDivWords.push([
              `.div-id-${divId}`,
              obj[divId][i]['word'],
              highlightClass,
            ])
          }
        }
      }
      this.setState({ highlightableDivWords: highlightableDivWords })
    } else if (flag == 2) {
      // word, pos
      var tempData = Object.assign({}, this.profileData)
      if (currentSection == 'Headline') {
        tempData['sectionWiseText'][sectionUnderscore[currentSection]] =
          wrapHeadline(
            this.props.feedback['section_wise_feedback']['headline_feedback'][
              'text_array'
            ],
            obj,
            isGenAiFeedback
          )
      } else if (
        currentSection == 'Summary' ||
        currentSection == 'Experience' ||
        currentSection == 'Education'
      ) {
        tempData['sectionWiseText'][sectionUnderscore[currentSection]] =
          wrapText(
            this.props.feedback['section_wise_feedback'],
            sectionUnderscore[currentSection] + '_feedback',
            obj,
            isGenAiFeedback
          )
      }

      const { updateText } = this.props
      updateText({
        updateKeys: [['sectionWiseText', sectionUnderscore[currentSection]]],
        data: tempData,
      })
      var highlightableDivWords = []
      for (var divId in obj) {
        for (var i in obj[divId]) {
          if (highlightClass == '') {
            highlightableDivWords.push([
              `.div-id-${divId}.word-pos.highlightable`,
              obj[divId][i]['word'],
              'addClass',
            ])
          } else {
            highlightableDivWords.push([
              `.div-id-${divId}.word-pos.highlightable`,
              obj[divId][i]['word'],
              highlightClass,
            ])
          }
        }
      }
      this.setState({ highlightableDivWords: highlightableDivWords })
    } else if (flag == 3) {
      var highlightableDivIds = []
      for (var i in obj) {
        if (highlightClass == '') {
          highlightableDivIds.push([`.div-id-${obj[i]}`, 'highlight-div'])
        } else {
          highlightableDivIds.push([`.div-id-${obj[i]}`, highlightClass])
        }
      }
      this.setState({ highlightableDivIds: highlightableDivIds })
    } else if (flag == 4) {
      var highlightableDivWords = []
      for (var i in obj['ids']) {
        highlightableDivWords.push([
          `.div-id-${obj['ids'][i]}`,
          obj['word'],
          'highlight',
        ])
      }
      this.setState({ highlightableDivWords: highlightableDivWords })
    } else if (flag == 5) {
      var highlightableDivIds = []
      for (var i in obj) {
        highlightableDivIds.push([`'.div-id-${obj[i]} a`, 'highlight-div'])
      }
      this.setState({ highlightableDivIds: highlightableDivIds })
    } else if (flag == 6) {
      var highlightableDivIds = []
      for (var i in obj['div_ids']) {
        highlightableDivIds.push([
          `.div-id-${obj['div_ids'][i]}`,
          'highlight-div',
        ])
      }

      // word
      var highlightableDivWords = []
      for (var divId in obj['weak_obj']) {
        for (var i in obj['weak_obj'][divId]) {
          highlightableDivWords.push([
            `.div-id-${divId}`,
            obj['weak_obj'][divId][i]['word'],
            'highlight-red',
          ])
        }
      }

      this.setState({
        highlightableDivIds: highlightableDivIds,
        highlightableDivWords: highlightableDivWords,
      })
    } else if (flag == 7) {
      var highlightableDivIds = []
      for (var i in obj['div_ids']) {
        highlightableDivIds.push([
          `.div-id-${obj['div_ids'][i]}`,
          'highlight-div',
        ])
      }

      // word, pos
      var tempData = Object.assign({}, this.profileData)
      if (currentSection == 'Headline') {
        tempData['sectionWiseText'][sectionUnderscore[currentSection]] =
          wrapHeadline(
            this.props.feedback['section_wise_feedback']['headline_feedback'][
              'text_array'
            ],
            obj['weak_obj'],
            isGenAiFeedback
          )
      } else if (
        currentSection == 'Summary' ||
        currentSection == 'Experience' ||
        currentSection == 'Education'
      ) {
        tempData['sectionWiseText'][sectionUnderscore[currentSection]] =
          wrapText(
            this.props.feedback['section_wise_feedback'],
            sectionUnderscore[currentSection] + '_feedback',
            obj['weak_obj'],
            isGenAiFeedback
          )
      }

      const { updateText } = this.props
      updateText({
        updateKeys: [['sectionWiseText', sectionUnderscore[currentSection]]],
        data: tempData,
      })
      var highlightableDivWords = []
      for (var divId in obj['weak_obj']) {
        for (var i in obj['weak_obj'][divId]) {
          highlightableDivWords.push([
            `.div-id-${divId}.word-pos.highlightable`,
            obj['weak_obj'][divId][i]['word'],
            'addClass-red',
          ])
        }
      }
      this.setState({
        highlightableDivIds: highlightableDivIds,
        highlightableDivWords: highlightableDivWords,
      })
    } else if (flag == 8) {
      var tempData = Object.assign({}, this.profileData)
      if (
        currentSection == 'Summary' ||
        currentSection == 'Experience'
      ) {
        tempData['sectionWiseText'][sectionUnderscore[currentSection]] =
          wrapText(
            this.props.feedback['section_wise_feedback'],
            sectionUnderscore[currentSection] + '_feedback',
            obj,
            isGenAiFeedback
          )
      }

      const { updateText } = this.props
      updateText({
        updateKeys: [['sectionWiseText', sectionUnderscore[currentSection]]],
        data: tempData,
      })
      var highlightableDivWords = []
      for (var divId in obj) {
        for (var i in obj[divId]) {
          if (obj[divId][i]['color'] == '') {
            highlightableDivWords.push([
              `.div-id-${divId}.word-pos.highlightable`,
              obj[divId][i]['word'],
              'addClass',
            ])
          } else {
            highlightableDivWords.push([
              `.div-id-${divId}.word-pos.highlightable`,
              obj[divId][i]['word'],
              'highlight-' + obj[divId][i]['color'],
            ])
          }
        }
      }
      this.setState({ highlightableDivWords: highlightableDivWords })
    }
    this.setState({ highlightedSection: currentSection })
  }

  highlightEntityText(
    submodule,
    buttonLabel,
    type,
    finalHighlightTexts = [],
    idsObj = []
  ) {
    const {
      dataSkills,
      dataContent,
      dataLanguage,
      dataImpact,
      dataRephraseWords,
      ui,
    } = this.props
    const { sectionsEntitiesToHighlight } = ui
    let texts = {}
    let highlightableEditDivWords = []
    let currentSection = ui['section']
    let currentIndex = ui[currentSection]['currentIndex']
    if (type == 'static') {
      if (submodule == 'categories') {
        texts = ''
        if (
          sectionsEntitiesToHighlight[currentSection][submodule][currentIndex][
            buttonLabel
          ]
        ) {
          texts =
            sectionsEntitiesToHighlight[currentSection][submodule][
              currentIndex
            ][buttonLabel].text
        }
      } else if (submodule == 'skills') {
        if (currentSection == 'Headline') {
          if (
            !_.isEmpty(idsObj) &&
            idsObj.hasOwnProperty(0) &&
            idsObj[0].hasOwnProperty('stated_actual_keyword') &&
            idsObj[0]['stated_actual_keyword'] != ''
          ) {
            texts = [
              { entity: 'text', text: idsObj[0]['stated_actual_keyword'] },
            ]
          } else {
            texts = [{ entity: 'text', text: buttonLabel }]
          }
        } else {
          texts =
            sectionsEntitiesToHighlight[currentSection][submodule][
              'relevant_skills_present'
            ][currentIndex][buttonLabel]
        }
      } else if (['language', 'impact'].includes(submodule)) {
        texts =
          sectionsEntitiesToHighlight[currentSection][submodule][buttonLabel][
            currentIndex
          ].text
      } else if (submodule == 'seo') {
        texts =
          sectionsEntitiesToHighlight[currentSection][submodule]['relevant'][
            currentIndex
          ][buttonLabel]
      } else if (submodule == 'presentation') {
        texts =
          sectionsEntitiesToHighlight[currentSection][submodule][buttonLabel][
            currentIndex
          ].text
      }
    } else {
      if (['categories', 'skills'].includes(submodule)) {
        texts = finalHighlightTexts
      } else if (submodule == 'language') {
        texts = dataLanguage[buttonLabel]['highlightValues']
      } else if (submodule == 'impact') {
        texts = dataImpact[buttonLabel]['highlightValues']
      } else if (submodule == 'rephrase_words') {
        texts = dataRephraseWords[buttonLabel]['highlightValues']
      }
    }
    let textArray = []
    let colorArray = []
    for (let i in texts) {
      highlightableEditDivWords.push([
        '.' +
          sectionUnderscore[currentSection] +
          '-entity-' +
          texts[i]['entity'],
        texts[i]['text'],
        submodule,
      ])
      let escapedText = texts[i]['text'].replace(/\.$/, '')
      escapedText = escapedText
        .replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
      // escapedText = '([\\b\\W]|^)' + escapedText + '([\\b\\W]|$)'
      // escapedText = '(?!\\n[\\b\\W]|^)*' + escapedText + '(?=[\\b\\W]|$)'  anmol
      // escapedText = '(?!\\n[\\W]|^)*\\b' + escapedText + '(?=[\\b\\W]|$)'
      escapedText =
        '(?!\\n[\\W]|^)*(\\b(?=[\\w])|)' + escapedText + '(?=[\\b\\W]|$)'
      textArray.push(escapedText)
      if (texts[i]?.['color'] === 'red') colorArray.push({ color: 'red', text: texts[i]['text'] });
      if (texts[i]?.['color'] === 'green') colorArray.push({ color: 'green', text: texts[i]['text'] });
    }
    let regexString = ''
    if (!_.isEmpty(texts)) {
      regexString = new RegExp(textArray.join('|'), 'ig')
    }

    if(colorArray.length > 0) {
      this.highlightableEditDivWords = [regexString, submodule, colorArray]
    }
    else this.highlightableEditDivWords = [regexString, submodule]
    this.setState({ highlightableEditDivWords })

    if (!_.isUndefined(this.interval)) {
      clearInterval(this.interval)
    }

    this.interval = setInterval(() => this.checkIfEditHighlighDone(), 200)

    setTimeout(() => {
      clearInterval(this.interval)
    }, 2000)
  }

  checkIfEditHighlighDone() {
    let ele = $('.hwt-container textarea')
    let ele1 = $('.hwt-highlights mark:first')

    if (!_.isUndefined(ele[0]) && !_.isUndefined(ele1[0])) {
      $('.hwt-container textarea').animate(
        {
          scrollTop:
            $('.hwt-container textarea').scrollTop() +
            $('.hwt-highlights mark:first').offset().top -
            $('.hwt-container textarea').offset().top,
        },
        {
          specialEasing: {
            width: 'linear',
            height: 'easeOutBounce',
          },
        }
      )

      clearInterval(this.interval)
    }
  }

  checkAlreadyParsed() {
    const {
      totalScore,
      totalScoreColor,
      resumeSkillsInLinkedin,
      resumeSkillsNotInLinkedin,
      derivedSkills,
      sectionWiseText,
      sectionWiseTextPdf,
      sections,
      sectionsPerSkill,
      sectionWiseTextEditable,
      sectionWiseTextStatic,
      sectionsEntitiesToHighlight,
      logs,
    } = this.props.ui
    if (!_.isEmpty(totalScoreColor)) {
      return {
        totalScore: totalScore,
        totalScoreColor: totalScoreColor,
        resumeSkillsInLinkedin: resumeSkillsInLinkedin,
        resumeSkillsNotInLinkedin: resumeSkillsNotInLinkedin,
        sectionWiseText: sectionWiseText,
        sectionWiseTextPdf: sectionWiseTextPdf,
        derivedSkills: derivedSkills,
        sections: sections,
        sectionsPerSkill: sectionsPerSkill,
        sectionWiseTextEditable: sectionWiseTextEditable,
        sectionWiseTextStatic: sectionWiseTextStatic,
        sectionsEntitiesToHighlight: sectionsEntitiesToHighlight,
        logs: logs,
      }
    } else {
      return {}
    }
  }

  fetchProfileData(feedback) {
    const { update_detailed_state, uploaded_picture, imageData } = this.props

    if (update_detailed_state == false && imageData.update_store == false) {
      let checkOutput = this.checkAlreadyParsed()
      if (!_.isEmpty(checkOutput)) {
        return checkOutput
      }
    }

    let totalScore =
      feedback['summary_screen']['overall_total_score_class']['overall_score']
    let totalScoreColor =
      feedback['summary_screen']['overall_total_score_class']['color_feedback']
    let resumeSkillsInLinkedin = [].concat(
      _.keys(feedback['skills_in_resume_in_linkedin']['hard_skills']),
      _.keys(feedback['skills_in_resume_in_linkedin']['sub_competency'])
    )
    let resumeSkillsNotInLinkedin = [].concat(
      _.keys(feedback['skills_in_resume_not_in_linkedin']['hard_skills']),
      _.keys(feedback['skills_in_resume_not_in_linkedin']['sub_competency'])
    )
    let suggestedSkills = feedback['suggested_skills']

    let newSectionSuggestedSkills = feedback['new_section_suggested_skills']

    let sectionFeedback = feedback['section_wise_feedback']
    if (
      _.isNull(
        sectionFeedback['personal_information_feedback'][
          'connections_score_class'
        ]['connections']
      )
    ) {
      sectionFeedback['personal_information_feedback'][
        'connections_score_class'
      ]['connections'] = 0
    }
    if (
      !sectionFeedback['personal_information_feedback'][
        'connections_score_class'
      ].hasOwnProperty('connections_threshold')
    ) {
      sectionFeedback['personal_information_feedback'][
        'connections_score_class'
      ]['connections_threshold'] = 500
    }
    let personal_info = [
      sectionFeedback['personal_information_feedback']['current_company'],
      sectionFeedback['personal_information_feedback']['latest_school'],
      sectionFeedback['personal_information_feedback']['user_location'],
    ]
    personal_info = personal_info.filter(
      (item) => !_.isEmpty(item) && !_.isUndefined(item)
    )
    personal_info = personal_info.join(' . ')

    let sectionWiseText = {
      imageUrl:
        uploaded_picture != '' &&
        !_.isUndefined(uploaded_picture) &&
        uploaded_picture['url'] != ''
          ? uploaded_picture['url']
          : getNestedValue(
              sectionFeedback,
              'profile_picture_feedback.profile_picture_url',
              ''
            ),
      imageString:
        uploaded_picture != '' && !_.isUndefined(uploaded_picture)
          ? uploaded_picture['string']
          : '',
      name: sectionFeedback['personal_information_feedback'][
        'profile_name_score_class'
      ]['name'],
      personal_information: personal_info,
      profile_url:
        sectionFeedback['personal_information_feedback']['url_score_class'][
          'url'
        ],
      suggested_urls:
        sectionFeedback['personal_information_feedback']['suggested_urls'],
      headline: wrapHeadline(
        sectionFeedback['headline_feedback']['text_array']
      ),
      summary: wrapText(sectionFeedback, 'summary_feedback'),
      experience: wrapText(sectionFeedback, 'experience_feedback'),
      education: wrapText(sectionFeedback, 'education_feedback'),
    }
    this.derivedSkills = {}
    let sections = this.getSectionContent(sectionFeedback, feedback)
    let sectionWiseTextPdf = $.extend(true, {}, sectionWiseText)
    let sectionWiseTextEditable = this.getSectionWiseTextEditable(
      sectionWiseText,
      sections['Profile Picture']
    )
    let entityMapEditable = this.getEditableEntitiesForHighlighting(
      sectionWiseTextEditable
    )
    let sectionsPerSkill = this.getSectionsPerSkill(sections)
    let sectionsEntitiesToHighlight = this.getSectionEntitiesToHighlight(
      sections,
      entityMapEditable
    )

    if (_.isNull(sections['Summary']['impact'])) {
      delete sections['Summary']['impact']
      delete sectionsEntitiesToHighlight['Summary']['impact']
    }
    sectionWiseTextEditable = this.entityTextKeys(sectionWiseTextEditable)
    let sectionWiseTextStatic = $.extend(true, {}, sectionWiseTextEditable)
    let logs = this.getLogs()

    return {
      totalScore: totalScore,
      totalScoreColor: totalScoreColor,
      resumeSkillsInLinkedin: resumeSkillsInLinkedin,
      resumeSkillsNotInLinkedin: resumeSkillsNotInLinkedin,
      suggestedSkills: suggestedSkills,
      newSectionSuggestedSkills: newSectionSuggestedSkills,
      sectionWiseText: sectionWiseText,
      sectionWiseTextPdf: sectionWiseTextPdf,
      derivedSkills: this.derivedSkills,
      sections: sections,
      sectionsPerSkill: sectionsPerSkill,
      sectionWiseTextEditable: sectionWiseTextEditable,
      sectionWiseTextStatic: sectionWiseTextStatic,
      sectionsEntitiesToHighlight: sectionsEntitiesToHighlight,
      logs: logs,
    }
  }

  getSectionEntitiesToHighlight(sections, entityMapEditable) {
    const functionEntityMap = {
      language: this.getLanguageEntities,
      impact: this.getImpactEntities,
      categories: this.getCategoriesEntities,
      skills: this.getSkillsEntities,
      seo: this.getSeoEntities,
      presentation: this.getPresentationEntities,
    }
    let output = {}
    _.mapObject(SECTION_TO_HIGHLIGHT_ENTITIES_MAP, (entities, section) => {
      output[section] = {}
      entities.map((entity) => {
        output[section][entity] = functionEntityMap[entity].call(
          this,
          sections[section][entity],
          entityMapEditable
        )
      })
    })

    return output
  }

  

  getSectionContent(sectionFeedback, feedback) {
    const {
      personal_information_feedback: PIFeedback,
      profile_picture_feedback: PictureFeedback = {},
      headline_feedback: HeadlineFeedback,
      summary_feedback: SummaryFeedback,
      experience_feedback: ExpFeedback,
      education_feedback: EduFeedback,
    } = sectionFeedback

    return {
      'Personal Information': {
        section: 'yellow',
        name: getNestedValue(
          PIFeedback,
          'profile_name_score_class.color_feedback',
          ''
        ),
        url: getNestedValue(PIFeedback, 'url_score_class.color_feedback', ''),
        connections: getNestedValue(
          PIFeedback,
          'connections_score_class.color_feedback',
          0
        ),
        connections_threshold: getNestedValue(
          PIFeedback,
          'connections_score_class.connections_threshold',
          500
        ),
        section_score: getSectionScore(PIFeedback),
      },
      'Profile Picture': !_.isEmpty(PictureFeedback)
        ? {
            section: PictureFeedback['image_score_class']['color_feedback'],
            face_frame_ratio: PictureFeedback['face_frame_ratio_feedback'],
            background: PictureFeedback['background_illumination_feedback'],
            foreground: PictureFeedback['foreground_illumination_feedback'],
            resolution: PictureFeedback['image_resolution_feedback'],
            symmetry: PictureFeedback['shoulder_symmetry_feedback'],
            face_body_ratio: PictureFeedback['face_body_ratio_feedback'],
            professional_clothes:
              PictureFeedback['professional_clothes_feedback'],
            pupil: PictureFeedback['pupil_feedback'],
            smile: PictureFeedback['smile_feedback'],
            section_score: getSectionScore(PictureFeedback),
          }
        : {
            section: 'red',
            face_frame_ratio: { feedback: <FormattedMessage id="aspire.detailedFeedback.notDetected" defaultMessage="Not Detected" /> },
            background: { feedback: <FormattedMessage id="aspire.detailedFeedback.notDetected" defaultMessage="Not Detected" /> },
            foreground: { feedback: <FormattedMessage id="aspire.detailedFeedback.notDetected" defaultMessage="Not Detected" /> },
            resolution: { feedback: <FormattedMessage id="aspire.detailedFeedback.notDetected" defaultMessage="Not Detected" /> },
            symmetry: { feedback: <FormattedMessage id="aspire.detailedFeedback.notDetected" defaultMessage="Not Detected" /> },
            face_body_ratio: { feedback: <FormattedMessage id="aspire.detailedFeedback.notDetected" defaultMessage="Not Detected" /> },
            professional_clothes: { feedback: <FormattedMessage id="aspire.detailedFeedback.notDetected" defaultMessage="Not Detected" /> },
            pupil: { feedback: <FormattedMessage id="aspire.detailedFeedback.notDetected" defaultMessage="Not Detected" /> },
            smile: { feedback: <FormattedMessage id="aspire.detailedFeedback.notDetected" defaultMessage="Not Detected" /> },
            section_score: [{ color: 'red', score: 0 }],
          },
      Headline: !_.isEmpty(HeadlineFeedback)
        ? {
            word_count_class: [
              {
                color: getNestedValue(
                  HeadlineFeedback,
                  'char_count_score_class.color_feedback',
                  'red'
                ),
                count: getNestedValue(
                  HeadlineFeedback,
                  'char_count_score_class.char_count',
                  0
                ),
              },
            ],
            first_div_id: this.getFirstDivId(HeadlineFeedback, false),
            suggestions: [],
            language: this.getLanguage(HeadlineFeedback),
            presentation: this.getPresentation(HeadlineFeedback),
            categories: this.getCategories(HeadlineFeedback, false),
            categories_missing: this.getCategoriesMissing(
              HeadlineFeedback['categories_missing']
            ),
            categories_in_resume_not_in_linkedin:
              this.getCategoriesInResumeNotInLinkedin(
                sectionFeedback['summary_feedback'],
                'Headline'
              ),
            skills: this.getSkills(HeadlineFeedback, ['hard_skills']),
            seo: this.getSeo(HeadlineFeedback, false),
            experience_months: feedback.hasOwnProperty('experience_months')
              ? feedback['experience_months']
              : 0,
            is_professional: feedback.hasOwnProperty('is_professional')
              ? feedback['is_professional']
              : true,
            section_score: getSectionScore(HeadlineFeedback),
          }
        : {
            word_count_class: [{ color: 'red', count: 0 }],
            first_div_id: [],
            suggestions: [],
            language: {
              buzzwords: [],
              narrative_voice: [],
              spell_check: [],
              tense: [],
              verb_overusage: [],
              score: [],
            },
            presentation: {
              bullet_length: [],
            },
            categories: { categories: [], score: [] },
            categories_missing: [],
            categories_in_resume_not_in_linkedin: [],
            skills: {
              relevant_skills_missing: [],
              relevant_skills_present: [],
              score: [],
            },
            seo: { keywords: [], score: [] },
            experience_months: 0,
            is_professional: true,
            section_score: [],
          },
      Summary: !_.isEmpty(SummaryFeedback)
        ? {
            word_count_class: [
              {
                color: getNestedValue(
                  SummaryFeedback,
                  'word_count_score_class.color_feedback',
                  'red'
                ),
                count: getNestedValue(
                  SummaryFeedback,
                  'word_count_score_class.word_count',
                  0
                ),
              },
            ],
            first_div_id: this.getFirstDivId(SummaryFeedback, false),
            language: this.getLanguage(SummaryFeedback),
            impact: this.getImpact(SummaryFeedback, false, 'summary'),
            presentation: this.getPresentation(SummaryFeedback),
            categories: this.getCategories(SummaryFeedback, false),
            categories_missing: this.getCategoriesMissing(
              SummaryFeedback['categories_missing']
            ),
            categories_in_resume_not_in_linkedin:
              this.getCategoriesInResumeNotInLinkedin(
                SummaryFeedback,
                'Summary'
              ),
            skills: this.getSkills(SummaryFeedback),
            seo: this.getSeo(SummaryFeedback, false),
            experience_months: feedback.hasOwnProperty('experience_months')
              ? feedback['experience_months']
              : 0,
            is_professional: feedback.hasOwnProperty('is_professional')
              ? feedback['is_professional']
              : true,
            section_score: getSectionScore(SummaryFeedback),
          }
        : {
            word_count_class: [{ color: 'red', count: 0 }],
            first_div_id: [],
            language: {
              buzzwords: [{ color: 'green', ids: {} }],
              narrative_voice: [{ color: 'green', ids: {} }],
              spell_check: [{ color: 'green', ids: {} }],
              tense: [{ color: 'green', ids: {} }],
              verb_overusage: [{ color: 'green', ids: {} }],
              score: [{ color: 'green', score: 99.99 }],
            },
            presentation: {
              bullet_length: [],
              bullets_count: [],
              grammar: [],
            },
            categories: {
              categories: [{}],
              score: [{ color: 'green', score: 99.99 }],
            },
            categories_missing: [[]],
            categories_in_resume_not_in_linkedin: [],
            skills: {
              relevant_skills_missing: [[]],
              relevant_skills_present: [{}],
              score: [{ color: 'red', score: 0.01 }],
            },
            seo: {
              keywords: [{ irrelevant: {}, relevant: {} }],
              score: [{ color: 'red', score: 0.01 }],
            },
            experience_months: 0,
            is_professional: true,
            section_score: [],
          },
      Experience: !_.isEmpty(ExpFeedback)
        ? {
            experience_count: getNestedValue(
              ExpFeedback,
              'number_of_experiences.color_feedback',
              'red'
            ),
            first_div_id: this.getFirstDivId(ExpFeedback, true),
            word_count_class: ExpFeedback.hasOwnProperty(
              'word_count_score_class'
            )
              ? this.getWordCountClass(ExpFeedback['word_count_score_class'])
              : [],
            sub_section_bullet_feedback: ExpFeedback.hasOwnProperty(
              'sub_section_bullet_feedback'
            )
              ? ExpFeedback['sub_section_bullet_feedback']
              : [],
            language: this.getLanguage(ExpFeedback),
            impact: this.getImpact(ExpFeedback, true, 'experience'),
            presentation: this.getPresentation(ExpFeedback),
            categories: this.getCategories(ExpFeedback, true),
            categories_missing: this.getCategoriesMissing(
              ExpFeedback['categories_missing']
            ),
            categories_in_resume_not_in_linkedin:
              this.getCategoriesInResumeNotInLinkedin(
                ExpFeedback,
                'Experience'
              ),
            skills: this.getSkills(ExpFeedback),
            title_hard_skills: this.getExperienceTitleHardSkills(ExpFeedback),
            seo: this.getSeo(ExpFeedback, true),
            recommended_title: this.getRecommendedTitle(ExpFeedback),
            experience_months: this.getExperienceDuration(
              ExpFeedback['cumulative_experience_per_subsection'],
              ExpFeedback['number_of_experiences']
            ),
            experience_case: ExpFeedback.hasOwnProperty('sample_tags')
              ? ExpFeedback['sample_tags']
              : [],
            job_function_mapping: ExpFeedback.hasOwnProperty(
              'job_function_mapping_per_sub_section'
            )
              ? this.mapToFrontEndName(
                  ExpFeedback['job_function_mapping_per_sub_section']
                )
              : [],
            section_score: getSectionScore(ExpFeedback, true),
          }
        : {
            experience_count: 'red',
            first_div_id: [],
            word_count_class: [],
            sub_section_bullet_feedback: [],
            language: {
              buzzwords: [],
              narrative_voice: [],
              spell_check: [],
              tense: [],
              verb_overusage: [],
              score: [],
            },
            impact: {
              action_oriented: [],
              action_oriented_color: [],
              specifics: [],
              specifics_color: [],
              score: [],
            },
            presentation: {
              bullet_length: [],
              bullets_count: [],
              grammar: [],
            },
            categories: { categories: [], score: [] },
            categories_missing: [],
            categories_in_resume_not_in_linkedin: [],
            skills: {
              relevant_skills_missing: [],
              relevant_skills_present: [],
              score: [],
            },
            seo: { keywords: [], score: [] },
            experience_months: [],
            experience_case: [],
            job_function_mapping: [],
            section_score: [],
          },
      Education: !_.isEmpty(EduFeedback)
        ? {
            first_div_id: this.getFirstDivId(EduFeedback, true),
            categories: this.getCategories(EduFeedback, true),
            categories_missing: this.getCategoriesMissing(
              EduFeedback['categories_missing']
            ),
            categories_in_resume_not_in_linkedin:
              this.getCategoriesInResumeNotInLinkedin(
                sectionFeedback['experience_feedback'],
                'Education'
              ),
            seo: this.getSeo(EduFeedback, true),
            section_score: getSectionScore(EduFeedback, true),
            presentation: this.getPresentation(EduFeedback),
            community_name_match: this.getFeedbackKey(
              EduFeedback,
              'community_name_match'
            ),
            community_name: this.getFeedbackKey(EduFeedback, 'community_name'),
          }
        : {
            first_div_id: [],
            categories: { categories: [], score: [] },
            categories_missing: [],
            categories_in_resume_not_in_linkedin: [],
            seo: { keywords: [], score: [] },
            section_score: [],
            community_name_match: null,
            community_name: null,
            presentation: {
              bullet_length: [],
              bullets_count: []
            },
          },
    }
  }

  getFeedbackKey(sectionFeedback, key) {
    return _.isUndefined(sectionFeedback[key]) ? null : sectionFeedback[key]
  }

  getSectionWiseTextEditable(sectionWiseText, profilePictureSections) {
    let sectionWiseTextEditable = {
      personal_information: [
        {
          name: sectionWiseText['name'],
          profile_url: sectionWiseText['profile_url'],
        },
      ],
      headline: [
        {
          text: {
            text: _.isUndefined(sectionWiseText['headline'])
              ? ''
              : sectionWiseText['headline']['text'][0],
            div_ids: [
              {
                div_id: _.isUndefined(sectionWiseText['headline'])
                  ? ''
                  : sectionWiseText['headline']['div_id'],
              },
            ], // empty is just for filling case
          },
        },
      ],
      summary: [
        { text: convertDomToString(sectionWiseText['summary']['text']) },
      ],
    }

    const { imageData } = this.props
    const imageParameters = [
      'face_frame_ratio',
      'background',
      'foreground',
      'resolution',
      'symmetry',
      'face_body_ratio',
      'professional_clothes',
      'pupil',
      'smile',
    ]
    let profilePicture = {}
    profilePicture['picture_url'] = _.isNull(imageData['url'])
      ? sectionWiseText['imageUrl']
      : imageData['url']
    profilePicture['picture_string'] = _.isEmpty(imageData['string'])
      ? sectionWiseText['imageString']
      : imageData['string']
    profilePicture['original_string'] = imageData['original_image_string']
    for (var i in imageParameters) {
      if (!_.isNull(imageData[imageParameters[i]])) {
        profilePicture[imageParameters[i]] = imageData[imageParameters[i]]
      } else if (profilePictureSections.hasOwnProperty(imageParameters[i])) {
        profilePicture[imageParameters[i]] =
          profilePictureSections[imageParameters[i]]
      }
    }
    sectionWiseTextEditable['profile_picture'] = [profilePicture]
    let experience = []
    for (var i in sectionWiseText['experience']) {
      let temp = convertDomToString(sectionWiseText['experience'][i]['title'])
      temp['text'] = temp['text'].split(/[\s]+(at)[\s]+/)
      let tempExp = {}
      let size = _.size(temp['text'])
      if (size >= 3 && temp['text'][1] == 'at') {
        tempExp['title'] = {
          text: temp['text'].slice(0, 1).join(' '),
          div_ids: temp['div_ids'],
        }
        tempExp['company'] = {
          text: temp['text'].slice(2).join(' '),
          div_ids: temp['div_ids'],
        }
      } else {
        tempExp['title'] = {
          text: temp['text'].join(' '),
          div_ids: temp['div_ids'],
        }
        tempExp['company'] = { text: '', div_ids: [] }
      }

      let duration = convertDomToString(
        sectionWiseText['experience'][i]['sub_title']
      )
      duration['text'] = duration['text'].split(/[\s]+(-)[\s]+/)
      tempExp['from'] = $.extend(true, {}, duration)
      tempExp['from']['text'] = tempExp['from']['text'][0]
      tempExp['to'] = $.extend(true, {}, duration)
      tempExp['to']['text'] = tempExp['to']['text'].pop().split(' (')[0]
      tempExp['text'] = convertDomToString(
        sectionWiseText['experience'][i]['text']
      )
      experience.push(tempExp)
    }
    sectionWiseTextEditable['experience'] = experience
    let education = []
    var entities =
      this.props.feedback['section_wise_feedback']['education_feedback'][
        'education_entities'
      ]
    for (var i in sectionWiseText['education']) {
      let tempEdu = {}
      tempEdu['school'] = {
        text: entities[i].hasOwnProperty('name') ? entities[i]['name'] : '',
        div_ids: [
          { div_id: sectionWiseText['education'][i]['title'][0]['div_id'] },
        ],
      }
      tempEdu['from'] = { text: '', div_ids: [] }
      tempEdu['to'] = { text: '', div_ids: [] }
      tempEdu['degree'] = { text: '', div_ids: [] }
      tempEdu['field_of_study'] = { text: '', div_ids: [] }

      if (!_.isEmpty(sectionWiseText['education'][i]['sub_title'])) {
        let divId = sectionWiseText['education'][i]['sub_title'][0]['div_id']
        // var timeDuration = entities[i].hasOwnProperty('time_duration') ? entities[i]['time_duration'].split(' - ') : []
        if (
          entities[i].hasOwnProperty('time_duration') &&
          entities[i]['time_duration'].hasOwnProperty('start_date') &&
          entities[i]['time_duration']['start_date'].hasOwnProperty('year')
        ) {
          tempEdu['from'] = {
            text: entities[i]['time_duration']['start_date']['year'].toString(),
            div_ids: [{ div_id: divId }],
          }
        }
        if (
          entities[i].hasOwnProperty('time_duration') &&
          entities[i]['time_duration'].hasOwnProperty('end_date') &&
          entities[i]['time_duration']['end_date'].hasOwnProperty('year')
        ) {
          tempEdu['to'] = {
            text: entities[i]['time_duration']['end_date']['year'].toString(),
            div_ids: [{ div_id: divId }],
          }
        }
        if (entities[i].hasOwnProperty('degree')) {
          tempEdu['degree'] = {
            text: entities[i]['degree'],
            div_ids: [{ div_id: divId }],
          }
        }
        if (entities[i].hasOwnProperty('field_of_study')) {
          tempEdu['field_of_study'] = {
            text: entities[i]['field_of_study'].trim(),
            div_ids: [{ div_id: divId }],
          }
        }
      }

      tempEdu['activities_and_societies'] = this.getEducationTextContent(
        sectionWiseText['education'][i]['text']
      )

      education.push(tempEdu)
    }
    sectionWiseTextEditable['education'] = education

    return sectionWiseTextEditable
  }

  getEducationTextContent(textArray) {
    let text = ''
    let divIds = []
    for (let divId in textArray) {
      if (
        textArray[divId]['is_title'] ||
        textArray[divId]['is_sub_title'] ||
        textArray[divId]['is_time_duration']
      ) {
        continue
      }

      text += textArray[divId]['text']
      text += '\n'
      divIds.push({ div_id: textArray[divId]['div_id'] })
    }
    text = text.replace('Activities and Societies:', '')

    return { text: text.trim(), div_ids: divIds }
  }

  getEditableEntitiesForHighlighting(sectionWiseTextEditable) {
    let divMap = {}
    let secKeys = ['headline', 'summary', 'experience', 'education']
    for (let i in secKeys) {
      for (let sectionIndex in sectionWiseTextEditable[secKeys[i]]) {
        for (let entity in sectionWiseTextEditable[secKeys[i]][sectionIndex]) {
          for (let j in sectionWiseTextEditable[secKeys[i]][sectionIndex][
            entity
          ]['div_ids']) {
            if (
              !divMap.hasOwnProperty(
                sectionWiseTextEditable[secKeys[i]][sectionIndex][entity][
                  'div_ids'
                ][j]['div_id']
              )
            ) {
              divMap[
                sectionWiseTextEditable[secKeys[i]][sectionIndex][entity][
                  'div_ids'
                ][j]['div_id']
              ] = []
            }
            let text =
              sectionWiseTextEditable[secKeys[i]][sectionIndex][entity][
                'div_ids'
              ][j]['text']
            if (secKeys[i] == 'experience') {
              if (entity == 'title') {
                let title = text.split(/[\s]+(at)[\s]+/)
                let size = _.size(title)
                if (size >= 3 && title[1] == 'at') {
                  title = title.slice(0, 1).join(' ')
                } else {
                  title = title.join(' ')
                }
                text = title
              } else if (entity == 'company') {
                let company = text.split(/[\s]+(at)[\s]+/)
                let size = _.size(company)
                if (size >= 3 && company[1] == 'at') {
                  company = company.slice(2).join(' ')
                } else {
                  company = ''
                }

                text = company
              }
            }
            divMap[
              sectionWiseTextEditable[secKeys[i]][sectionIndex][entity][
                'div_ids'
              ][j]['div_id']
            ].push([secKeys[i], sectionIndex, entity, text])
          }
        }
      }
    }

    return divMap
  }
  entityTextKeys(sectionWiseTextEditable) {
    let secKeys = ['headline', 'summary', 'experience', 'education']
    for (let i in secKeys) {
      for (let sectionIndex in sectionWiseTextEditable[secKeys[i]]) {
        for (let entity in sectionWiseTextEditable[secKeys[i]][sectionIndex]) {
          sectionWiseTextEditable[secKeys[i]][sectionIndex][entity] =
            sectionWiseTextEditable[secKeys[i]][sectionIndex][entity]['text']
        }
      }
    }

    return sectionWiseTextEditable
  }

  getWordCountClass(wordCounts) {
    return _.map(wordCounts, function (val) {
      return { color: val['color_feedback'], count: val['word_count'] }
    })
  }

  getFirstDivId(sectionFeedback, isExperience) {
    let firstDivId = []
    if (!_.isUndefined(sectionFeedback['text_array'])) {
      if (!isExperience) {
        firstDivId.push(_.min(_.keys(sectionFeedback['text_array'])))
      } else {
        for (let i in sectionFeedback['text_array']) {
          firstDivId.push(_.min(_.keys(sectionFeedback['text_array'][i])))
        }
      }
    }

    return parseInt(firstDivId)
  }

  getLanguage(sectionFeedback) {
    let language = {}
    if (!_.isUndefined(sectionFeedback['overall_language_score_class'])) {
      language['score'] = []
      if (
        _.isUndefined(
          sectionFeedback['overall_language_score_class']['sub_section']
        )
      ) {
        language['score'].push({
          color:
            sectionFeedback['overall_language_score_class']['color_feedback'],
          score: lowerScore(
            sectionFeedback['overall_language_score_class'][
              'overall_language_score'
            ]
          ),
        })
      } else {
        for (var i in sectionFeedback['overall_language_score_class'][
          'sub_section'
        ]) {
          if (
            !sectionFeedback['overall_language_score_class']['sub_section'][
              i
            ].hasOwnProperty('sub_section_mapping') ||
            _.isNull(
              sectionFeedback['overall_language_score_class']['sub_section'][i][
                'sub_section_mapping'
              ]
            )
          ) {
            language['score'].push({
              color:
                sectionFeedback['overall_language_score_class']['sub_section'][
                  i
                ]['color_feedback'],
              score: lowerScore(
                sectionFeedback['overall_language_score_class']['sub_section'][
                  i
                ]['sample_score']
              ),
            })
          } else {
            language['score'][
              sectionFeedback['overall_language_score_class']['sub_section'][i][
                'sub_section_mapping'
              ]
            ] = {
              color:
                sectionFeedback['overall_language_score_class']['sub_section'][
                  i
                ]['color_feedback'],
              score: lowerScore(
                sectionFeedback['overall_language_score_class']['sub_section'][
                  i
                ]['sample_score']
              ),
            }
          }
        }
      }
    } else {
      language['score'] = [{ color: 'red', score: 0 }]
    }
    if (!_.isUndefined(sectionFeedback['buzzwords_score_class'])) {
      language['buzzwords'] = []
      for (var i in sectionFeedback['buzzwords_score_class']) {
        var ids = {}
        for (var j in sectionFeedback['buzzwords_score_class'][i][
          'buzzwords'
        ]) {
          var value =
            sectionFeedback['buzzwords_score_class'][i]['buzzwords'][j]
          if (!ids.hasOwnProperty(value['sentence_id'])) {
            ids[value['sentence_id']] = []
          }
          ids[value['sentence_id']].push({
            word: value['value'],
            pos: value['start_pos'],
          })
        }
        if (
          !sectionFeedback['buzzwords_score_class'][i].hasOwnProperty(
            'sub_section_mapping'
          ) ||
          _.isNull(
            sectionFeedback['buzzwords_score_class'][i]['sub_section_mapping']
          )
        ) {
          language['buzzwords'].push({
            color:
              sectionFeedback['buzzwords_score_class'][i][
                'buzzwords_color_feedback'
              ],
            ids: ids,
            pos_present: true,
          })
        } else {
          language['buzzwords'][
            sectionFeedback['buzzwords_score_class'][i]['sub_section_mapping']
          ] = {
            color:
              sectionFeedback['buzzwords_score_class'][i][
                'buzzwords_color_feedback'
              ],
            ids: ids,
            pos_present: true,
          }
        }
      }
    }
    if (!_.isUndefined(sectionFeedback['narrative_voice_score_class'])) {
      language['narrative_voice'] = []
      for (var i in sectionFeedback['narrative_voice_score_class']) {
        var ids = []
        for (var j in sectionFeedback['narrative_voice_score_class'][i][
          'narrative_voice_inconsistency'
        ]) {
          if (
            sectionFeedback['narrative_voice_score_class'][i][
              'narrative_voice_inconsistency'
            ][j]['previous_narrative_voice'] == 'first person' ||
            sectionFeedback['narrative_voice_score_class'][i][
              'narrative_voice_inconsistency'
            ][j]['previous_narrative_voice'] == 'third person'
          ) {
            ids.push(
              sectionFeedback['narrative_voice_score_class'][i][
                'narrative_voice_inconsistency'
              ][j]['prev_sentence_id']
            )
          }
          if (
            sectionFeedback['narrative_voice_score_class'][i][
              'narrative_voice_inconsistency'
            ][j]['current_narrative_voice'] == 'first person' ||
            sectionFeedback['narrative_voice_score_class'][i][
              'narrative_voice_inconsistency'
            ][j]['current_narrative_voice'] == 'third person'
          ) {
            ids.push(
              sectionFeedback['narrative_voice_score_class'][i][
                'narrative_voice_inconsistency'
              ][j]['current_sentence_id']
            )
          }
        }
        if (
          !sectionFeedback['narrative_voice_score_class'][i].hasOwnProperty(
            'sub_section_mapping'
          ) ||
          _.isNull(
            sectionFeedback['narrative_voice_score_class'][i][
              'sub_section_mapping'
            ]
          )
        ) {
          language['narrative_voice'].push({
            color:
              sectionFeedback['narrative_voice_score_class'][i][
                'narrative_voice_color_feedback'
              ],
            ids: _.uniq(ids),
          })
        } else {
          language['narrative_voice'][
            sectionFeedback['narrative_voice_score_class'][i][
              'sub_section_mapping'
            ]
          ] = {
            color:
              sectionFeedback['narrative_voice_score_class'][i][
                'narrative_voice_color_feedback'
              ],
            ids: _.uniq(ids),
          }
        }
      }
    }
    if (!_.isUndefined(sectionFeedback['spell_check_score_class'])) {
      language['spell_check'] = []
      for (var i in sectionFeedback['spell_check_score_class']) {
        var ids = {}
        for (var j in sectionFeedback['spell_check_score_class'][i][
          'spell_check'
        ]) {
          var value =
            sectionFeedback['spell_check_score_class'][i]['spell_check'][j]
          if (!ids.hasOwnProperty(value['sentence_id'])) {
            ids[value['sentence_id']] = []
          }
          ids[value['sentence_id']].push({ word: value['wrong_word'] })
          this.spellErrors.push([
            '.div-id-' + value['sentence_id'],
            value['wrong_word'],
          ])
        }
        if (
          !sectionFeedback['spell_check_score_class'][i].hasOwnProperty(
            'sub_section_mapping'
          ) ||
          _.isNull(
            sectionFeedback['spell_check_score_class'][i]['sub_section_mapping']
          )
        ) {
          language['spell_check'].push({
            color:
              sectionFeedback['spell_check_score_class'][i][
                'spell_check_color_feedback'
              ],
            ids: ids,
            pos_present: false,
          })
        } else {
          language['spell_check'][
            sectionFeedback['spell_check_score_class'][i]['sub_section_mapping']
          ] = {
            color:
              sectionFeedback['spell_check_score_class'][i][
                'spell_check_color_feedback'
              ],
            ids: ids,
            pos_present: false,
          }
        }
      }
    }
    if (!_.isUndefined(sectionFeedback['tense_score_class'])) {
      language['tense'] = []
      for (var i in sectionFeedback['tense_score_class']) {
        var ids = []
        for (var j in sectionFeedback['tense_score_class'][i][
          'tense_inconsistency'
        ]) {
          ids.push(
            sectionFeedback['tense_score_class'][i]['tense_inconsistency'][j][
              'prev_sentence_id'
            ]
          )
          ids.push(
            sectionFeedback['tense_score_class'][i]['tense_inconsistency'][j][
              'current_sentence_id'
            ]
          )
        }
        if (
          !sectionFeedback['tense_score_class'][i].hasOwnProperty(
            'sub_section_mapping'
          ) ||
          _.isNull(
            sectionFeedback['tense_score_class'][i]['sub_section_mapping']
          )
        ) {
          language['tense'].push({
            color:
              sectionFeedback['tense_score_class'][i]['tense_color_feedback'],
            ids: _.uniq(ids),
          })
        } else {
          language['tense'][
            sectionFeedback['tense_score_class'][i]['sub_section_mapping']
          ] = {
            color:
              sectionFeedback['tense_score_class'][i]['tense_color_feedback'],
            ids: _.uniq(ids),
          }
        }
      }
    }
    if (!_.isUndefined(sectionFeedback['verb_overusage_score_class'])) {
      language['verb_overusage'] = []
      for (var i in sectionFeedback['verb_overusage_score_class']) {
        var ids = {}
        for (var j in sectionFeedback['verb_overusage_score_class'][i][
          'verb_overusage'
        ]) {
          var value =
            sectionFeedback['verb_overusage_score_class'][i]['verb_overusage'][
              j
            ]
          if (!ids.hasOwnProperty(value['sentence_id'])) {
            ids[value['sentence_id']] = []
          }
          ids[value['sentence_id']].push({
            word: value['verb'],
            pos: value['positions'][0],
            suggestions: value['verb_suggestions'],
            module_type: 'verb_overusage',
          })
        }
        if (
          !sectionFeedback['verb_overusage_score_class'][i].hasOwnProperty(
            'sub_section_mapping'
          ) ||
          _.isNull(
            sectionFeedback['verb_overusage_score_class'][i][
              'sub_section_mapping'
            ]
          )
        ) {
          language['verb_overusage'].push({
            color:
              sectionFeedback['verb_overusage_score_class'][i][
                'verb_overusage_color_feedback'
              ],
            ids: ids,
            pos_present: true,
          })
        } else {
          language['verb_overusage'][
            sectionFeedback['verb_overusage_score_class'][i][
              'sub_section_mapping'
            ]
          ] = {
            color:
              sectionFeedback['verb_overusage_score_class'][i][
                'verb_overusage_color_feedback'
              ],
            ids: ids,
            pos_present: true,
          }
        }
      }
    }
    return language
  }

  getPresentation(sectionFeedback) {
    let presentation = {}
    if (!_.isUndefined(sectionFeedback['overall_presentation_score_class'])) {
      presentation['score'] = []
      if (
        _.isUndefined(
          sectionFeedback['overall_presentation_score_class']['sub_section']
        )
      ) {
        presentation['score'].push({
          color:
            sectionFeedback['overall_presentation_score_class'][
              'color_feedback'
            ],
          score:
            sectionFeedback['overall_presentation_score_class'][
              'overall_presentation_score'
            ],
        })
      } else {
        for (var i in sectionFeedback['overall_presentation_score_class'][
          'sub_section'
        ]) {
          presentation['score'].push({
            color:
              sectionFeedback['overall_presentation_score_class'][
                'sub_section'
              ][i]['color_feedback'],
            score:
              sectionFeedback['overall_presentation_score_class'][
                'sub_section'
              ][i]['sample_score'],
          })
        }
      }
    } else {
      presentation['score'] = [{ color: 'red', score: 0 }]
    }

    if (!_.isUndefined(sectionFeedback['bullet_length_score_class'])) {
      presentation['bullet_length'] = []
      presentation['bullet_length_color'] = []
      for (let i in sectionFeedback['bullet_length_score_class']) {
        presentation['bullet_length'].push({
          score: sectionFeedback['bullet_length_score_class'][i]['bullet_length_score'],
          color: sectionFeedback['bullet_length_score_class'][i]['bullet_length_color_feedback'],
        })
        presentation['bullet_length_color'].push({
          score: sectionFeedback['bullet_length_score_class'][i]['bullet_length_score'],
          color: sectionFeedback['bullet_length_score_class'][i]['bullet_length_color_feedback'],
        })
      }
    }
    if (!_.isUndefined(sectionFeedback['bullets_count_score_class'])) {
      presentation['bullets_count'] = []
      presentation['bullets_count_color'] = []
      for (let i in sectionFeedback['bullets_count_score_class']) {
        presentation['bullets_count'].push({
          score: sectionFeedback['bullets_count_score_class'][i]['bullets_count_score'],
          color: sectionFeedback['bullets_count_score_class'][i]['bullets_count_color_feedback'],
        })
        presentation['bullets_count_color'].push({
          score: sectionFeedback['bullets_count_score_class'][i]['bullets_count_score'],
          color: sectionFeedback['bullets_count_score_class'][i]['bullets_count_color_feedback'],
        })
      }
    }
    if (!_.isUndefined(sectionFeedback['grammar_score_class'])) {
      presentation['grammar'] = []
      presentation['grammar_color'] = []
      for (let i in sectionFeedback['grammar_score_class']) {
        presentation['grammar'].push({
          score: sectionFeedback['grammar_score_class'][i]['grammar_score'],
          color: sectionFeedback['grammar_score_class'][i]['grammar_color_feedback'],
          grammar: sectionFeedback['grammar_score_class'][i]['grammar'],
          grammar_count: sectionFeedback['grammar_score_class'][i]['grammar_count'],
        })
        presentation['grammar_color'].push({
          score: sectionFeedback['grammar_score_class'][i]['grammar_score'],
          color: sectionFeedback['grammar_score_class'][i]['grammar_color_feedback'],
          grammar: sectionFeedback['grammar_score_class'][i]['grammar'],
          grammar_count: sectionFeedback['grammar_score_class'][i]['grammar_count'],
        })
      }
    }
    return presentation
  }

  getPresentationEntities(sectionPresentation, entityMapEditable) {
    let presentationEntities = {};
    if (Array.isArray(sectionPresentation.grammar)) {
      presentationEntities['grammar'] = {};
      sectionPresentation.grammar.forEach((grammarObj, sectionIndex) => {
        let obj = {
          color: grammarObj.color,
          text: [],
        };
        if (grammarObj && grammarObj.grammar) {
          if (Array.isArray(grammarObj.grammar)) {
            for (let error of grammarObj.grammar) {
              for (let divId in entityMapEditable) {
                let entities = entityMapEditable[divId];
                for (let k in entities) {
                  if (
                    entities[k][3] &&
                    entities[k][3].toLowerCase().includes(error.toLowerCase())
                  ) {
                    obj.text.push({
                      entity: entities[k][2],
                      text: error,
                    });
                  }
                }
              }
            }
          } else if (typeof grammarObj.grammar === 'object') {
            Object.values(grammarObj.grammar).forEach(errorsArr => {
              if (Array.isArray(errorsArr)) {
                for (let error of errorsArr) {
                  for (let divId in entityMapEditable) {
                    let entities = entityMapEditable[divId];
                    for (let k in entities) {
                      if (
                        entities[k][3] &&
                        entities[k][3].toLowerCase().includes(error.toLowerCase())
                      ) {
                        obj.text.push({
                          entity: entities[k][2],
                          text: error,
                        });
                      }
                    }
                  }
                }
              }
            });
          }
        }
        presentationEntities['grammar'][sectionIndex] = obj;
      });
    }
    return presentationEntities;
  }

  getLanguageEntities(sectionLanguage, entityMapEditable) {
    let languageEntities = {}
    var subModules = ['buzzwords', 'spell_check', 'verb_overusage']
    for (var i in subModules) {
      if (sectionLanguage.hasOwnProperty(subModules[i])) {
        languageEntities[subModules[i]] = {}
        for (var sectionIndex in sectionLanguage[subModules[i]]) {
          var obj = {
            color: sectionLanguage[subModules[i]][sectionIndex]['color'],
            text: [],
          }
          for (let divId in sectionLanguage[subModules[i]][sectionIndex][
            'ids'
          ]) {
            var entities = entityMapEditable[divId]
            for (var j in sectionLanguage[subModules[i]][sectionIndex]['ids'][
              divId
            ]) {
              for (var k in entities) {
                obj['text'].push({
                  entity: entities[k][2],
                  text: sectionLanguage[subModules[i]][sectionIndex]['ids'][
                    divId
                  ][j]['word'],
                })
              }
            }
          }
          languageEntities[subModules[i]][sectionIndex] = obj
        }
      }
    }
    var subModules = ['narrative_voice', 'tense']
    for (var i in subModules) {
      if (sectionLanguage.hasOwnProperty(subModules[i])) {
        languageEntities[subModules[i]] = {}
        for (var sectionIndex in sectionLanguage[subModules[i]]) {
          var obj = {
            color: sectionLanguage[subModules[i]][sectionIndex]['color'],
            text: [],
          }
          for (var j in sectionLanguage[subModules[i]][sectionIndex]['ids']) {
            var entities =
              entityMapEditable[
                sectionLanguage[subModules[i]][sectionIndex]['ids'][j]
              ]
            for (var k in entities) {
              obj['text'].push({ entity: entities[k][2], text: entities[k][3] })
            }
          }
          languageEntities[subModules[i]][sectionIndex] = obj
        }
      }
    }

    return languageEntities
  }

  getImpact(sectionFeedback, isExperience, sectionName='') {
    const { isUKEnable, isGenAiFeedback } = this.props
    let impact = {}
    if (!_.isUndefined(sectionFeedback['overall_impact_score_class'])) {
      impact['score'] = []
      if (
        _.isUndefined(
          sectionFeedback['overall_impact_score_class']['sub_section']
        )
      ) {
        impact['score'].push({
          color:
            sectionFeedback['overall_impact_score_class']['color_feedback'],
          score: lowerScore(
            sectionFeedback['overall_impact_score_class'][
              'overall_impact_score'
            ]
          ),
        })
      } else {
        for (var i in sectionFeedback['overall_impact_score_class'][
          'sub_section'
        ]) {
          impact['score'].push({
            color:
              sectionFeedback['overall_impact_score_class']['sub_section'][i][
                'color_feedback'
              ],
            score: lowerScore(
              sectionFeedback['overall_impact_score_class']['sub_section'][i][
                'overall_impact_score'
              ]
            ),
          })
        }
      }
    }
    if (!_.isUndefined(sectionFeedback['impact_divs'])) {
      impact['action_oriented'] = []
      impact['action_oriented_color'] = []
      impact['specifics'] = []
      impact['specifics_color'] = []
      if (!isExperience) {
        var mods = { action_oriented: {}, specifics: {} }
        let bulletDivs = []
        for (var divId in sectionFeedback['impact_divs']['bullet_divs']) {
          bulletDivs.push(divId)
        }
        if ( !isGenAiFeedback && _.isEmpty(bulletDivs)) {
          return null
        }
        for (var divId in sectionFeedback['impactResultsArray']) {
          if (!_.contains(bulletDivs, divId)) {
            continue
          }
          if (
            sectionFeedback['impactResultsArray'][divId].hasOwnProperty(
              'active'
            )
          ) {
            if (!mods['action_oriented'].hasOwnProperty(divId)) {
              mods['action_oriented'][divId] = []
            }
            for (var k in sectionFeedback['impactResultsArray'][divId][
              'active'
            ]) {
              for (var j in sectionFeedback['impactResultsArray'][divId][
                'active'
              ][k]) {
                var weak =
                  sectionFeedback['impactResultsArray'][divId]['active'][k][j][
                    'weakVerb'
                  ]
                var suggestions = []
                var moduleType = ''
                if (weak == true) {
                  suggestions = [
                    <FormattedMessage id="aspire.detailedFeedback.weakVerbSuggestions.led" defaultMessage="Led" />,
                    <FormattedMessage id="aspire.detailedFeedback.weakVerbSuggestions.managed" defaultMessage="Managed" />,
                    isUKEnable
                      ? <FormattedMessage id="aspire.detailedFeedback.weakVerbSuggestions.analysed" defaultMessage="Analysed" />
                      : <FormattedMessage id="aspire.detailedFeedback.weakVerbSuggestions.analyzed" defaultMessage="Analyzed" />,
                    <FormattedMessage id="aspire.detailedFeedback.weakVerbSuggestions.created" defaultMessage="Created" />,
                  ]
                  moduleType = 'action_oriented'
                }
                mods['action_oriented'][divId].push({
                  word: sectionFeedback['impactResultsArray'][divId]['active'][
                    k
                  ][j]['originalKeyword'],
                  pos: sectionFeedback['impactResultsArray'][divId]['active'][
                    k
                  ][j]['wordPos'],
                  weak: weak,
                  suggestions: suggestions,
                  module_type: moduleType,
                })
              }
            }
          }
          if (
            sectionFeedback['impactResultsArray'][divId].hasOwnProperty(
              'specifics'
            )
          ) {
            if (!mods['specifics'].hasOwnProperty(divId)) {
              mods['specifics'][divId] = []
            }
            for (var k in sectionFeedback['impactResultsArray'][divId][
              'specifics'
            ]) {
              for (var j in sectionFeedback['impactResultsArray'][divId][
                'specifics'
              ][k]) {
                mods['specifics'][divId].push({
                  word: sectionFeedback['impactResultsArray'][divId][
                    'specifics'
                  ][k][j]['originalKeyword'],
                  pos: sectionFeedback['impactResultsArray'][divId][
                    'specifics'
                  ][k][j]['wordPos'],
                })
              }
            }
          }
        }
        impact['action_oriented'].push({
          ids: mods['action_oriented'],
          pos_present: true,
          color:
            sectionFeedback['overall_impact_score_class'][
              'active_score_color_feedback'
            ],
          score: lowerScore(
            sectionFeedback['overall_impact_score_class'][
              'overall_active_score'
            ]
          ),
        })
        impact['action_oriented_color'].push({
          color:
            sectionFeedback['overall_impact_score_class'][
              'active_score_color_feedback'
            ],
          score: lowerScore(
            sectionFeedback['overall_impact_score_class'][
              'overall_active_score'
            ]
          ),
        })
        impact['specifics'].push({
          ids: mods['specifics'],
          pos_present: true,
          color:
            sectionFeedback['overall_impact_score_class'][
              'specifics_score_color_feedback'
            ],
          score: lowerScore(
            sectionFeedback['overall_impact_score_class'][
              'overall_specifics_score'
            ]
          ),
        })
        impact['specifics_color'].push({
          color:
            sectionFeedback['overall_impact_score_class'][
              'specifics_score_color_feedback'
            ],
          score: lowerScore(
            sectionFeedback['overall_impact_score_class'][
              'overall_specifics_score'
            ]
          ),
        })
      } else {
        let impactDivsKeys = _.keys(sectionFeedback['impact_divs'])
        let impactResultsArrayKeys = _.keys(
          sectionFeedback['impactResultsArray']
        )
        for (let ii in impactDivsKeys) {
          var i = impactDivsKeys[ii]
          let impactResultsArrayKey = impactResultsArrayKeys[ii]
          var mods = { action_oriented: {}, specifics: {} }
          for (var divId in sectionFeedback['impactResultsArray'][
            impactResultsArrayKey
          ]) {
            if (
              sectionFeedback['impactResultsArray'][impactResultsArrayKey][
                divId
              ].hasOwnProperty('active')
            ) {
              if (!mods['action_oriented'].hasOwnProperty(divId)) {
                mods['action_oriented'][divId] = []
              }
              for (var k in sectionFeedback['impactResultsArray'][
                impactResultsArrayKey
              ][divId]['active']) {
                for (var j in sectionFeedback['impactResultsArray'][
                  impactResultsArrayKey
                ][divId]['active'][k]) {
                  var weak =
                    sectionFeedback['impactResultsArray'][
                      impactResultsArrayKey
                    ][divId]['active'][k][j]['weakVerb']
                  var suggestions = []
                  var moduleType = ''
                  if (weak == true) {
                    suggestions = [
                      <FormattedMessage id="aspire.detailedFeedback.weakVerbSuggestions.led" defaultMessage="Led" />,
                      <FormattedMessage id="aspire.detailedFeedback.weakVerbSuggestions.managed" defaultMessage="Managed" />,
                      <FormattedMessage id="aspire.detailedFeedback.weakVerbSuggestions.analyzed" defaultMessage="Analyzed" />,
                      <FormattedMessage id="aspire.detailedFeedback.weakVerbSuggestions.created" defaultMessage="Created" />
                    ]
                    moduleType = 'action_oriented'
                  }
                  mods['action_oriented'][divId].push({
                    word: sectionFeedback['impactResultsArray'][
                      impactResultsArrayKey
                    ][divId]['active'][k][j]['originalKeyword'],
                    pos: sectionFeedback['impactResultsArray'][
                      impactResultsArrayKey
                    ][divId]['active'][k][j]['wordPos'],
                    weak: weak,
                    suggestions: suggestions,
                    module_type: moduleType,
                  })
                }
              }
            }
            if (
              sectionFeedback['impactResultsArray'][impactResultsArrayKey][
                divId
              ].hasOwnProperty('specifics')
            ) {
              if (!mods['specifics'].hasOwnProperty(divId)) {
                mods['specifics'][divId] = []
              }
              for (var k in sectionFeedback['impactResultsArray'][
                impactResultsArrayKey
              ][divId]['specifics']) {
                for (var j in sectionFeedback['impactResultsArray'][
                  impactResultsArrayKey
                ][divId]['specifics'][k]) {
                  mods['specifics'][divId].push({
                    word: sectionFeedback['impactResultsArray'][
                      impactResultsArrayKey
                    ][divId]['specifics'][k][j]['originalKeyword'],
                    pos: sectionFeedback['impactResultsArray'][
                      impactResultsArrayKey
                    ][divId]['specifics'][k][j]['wordPos'],
                  })
                }
              }
            }
          }
          impact['action_oriented'].push({
            ids: mods['action_oriented'],
            pos_present: true,
            color:
              sectionFeedback['impact_divs'][i]['active_score_color_feedback'],
            score: lowerScore(
              sectionFeedback['impact_divs'][i]['active_score']
            ),
          })
          impact['action_oriented_color'].push({
            color:
              sectionFeedback['impact_divs'][i]['active_score_color_feedback'],
            score: lowerScore(
              sectionFeedback['impact_divs'][i]['active_score']
            ),
          })
          impact['specifics'].push({
            ids: mods['specifics'],
            pos_present: true,
            color:
              sectionFeedback['impact_divs'][i][
                'specifics_score_color_feedback'
              ],
            score: lowerScore(
              sectionFeedback['impact_divs'][i]['specifics_score']
            ),
          })
          impact['specifics_color'].push({
            color:
              sectionFeedback['impact_divs'][i][
                'specifics_score_color_feedback'
              ],
            score: lowerScore(
              sectionFeedback['impact_divs'][i]['specifics_score']
            ),
          })
        }
      }
      if(isGenAiFeedback)
      {
        let impactDivs = sectionFeedback['impact_divs']
        let impactResultsArray = sectionFeedback['impactResultsArray']
        if(sectionName === 'experience')
        {
          impactDivs = Array.isArray(impactDivs)
          ? impactDivs
          : impactDivs
            ? Object.values(impactDivs)
            : [];

          impactResultsArray = Array.isArray(impactResultsArray)
          ? impactResultsArray
          : impactResultsArray
            ? Object.values(impactResultsArray)
            : [];
        }
        if(!_.isEmpty(impactDivs) && sectionName === 'experience')
        { 
          if (!_.isEmpty(impactResultsArray)) {
            impactResultsArray.forEach((impactDiv, idx) => {
              if(_.isEmpty(impactDiv)) return;
              let actionOrientedIds = {}
              Object.entries(impactDiv).forEach(([divId, divObj]) => {
                const detections = divObj.action_oriented?.detection || [];
                if(detections.length !== 0) {
                  actionOrientedIds[divId] = detections.map(det => ({
                    word: det.word,
                    strength: det.strength?.status || null
                  }));
                }
              });
              if(!_.isEmpty(actionOrientedIds) &&
                impact['action_oriented'] &&
                impact['action_oriented'][idx] != null)
              {
                impact['action_oriented'][idx] = ({
                  ids: actionOrientedIds,
                  pos_present: true,
                  color: impactDivs[idx]?.active_score_color_feedback || 'red',
                  score: lowerScore(impactDivs[idx]?.active_score) || 0,
                })
                impact['action_oriented_color'][idx] = ({
                  color: impactDivs[idx]?.active_score_color_feedback || 'red',
                  score: lowerScore(impactDivs[idx]?.active_score) || 0,
                })
              }
            })
          }
          impactDivs.forEach((impactDiv, idx) => {
            if(_.isEmpty(impactDiv)) return;
            let specificsIds = {}
            if (!_.isEmpty(impactDiv.bullet_divs)) {
              Object.entries(impactDiv.bullet_divs).forEach(([divId, divObj]) => {
                if (divObj.specifics_score && Array.isArray(divObj.specifics_score.word)) {
                  specificsIds[divId] = divObj.specifics_score.word.map(w => ({
                    word: w.keyword,
                    pos: w.position,
                    color: divObj.specifics_score.color,
                  }))
                }
              })
            }
            if (!_.isEmpty(impactDiv.non_bullet_divs)) {
              Object.entries(impactDiv.non_bullet_divs).forEach(([divId, divObj]) => {
                if (
                  divObj.specifics_divs &&
                  Array.isArray(divObj.specifics_divs.div_ids)
                ) {
                  divObj.specifics_divs.div_ids.forEach(divInfo => {
                    if (divInfo.word && Array.isArray(divInfo.word)) {
                      specificsIds[divInfo.div_id] = divInfo.word.map(w => ({
                        word: w.keyword,
                        pos: w.position,
                        color: divObj.color,
                      }))
                    }
                  })
                }
              })
            }
            if(!_.isEmpty(specificsIds) && 
              impact['specifics'] &&
              impact['specifics'][idx] != null
            )
            {
              impact['specifics'][idx] = ({
                ids: specificsIds,
                pos_present: true,
                color: impactDiv.specifics_score_color_feedback,
                score: lowerScore(impactDiv.specifics_score),
              })
              impact['specifics_color'][idx] = ({
                color: impactDiv.specifics_score_color_feedback,
                score: lowerScore(impactDiv.specifics_score),
              })
            }
          });
        }

        if(!_.isEmpty(impactDivs) && sectionName === 'summary')
        { 
          let impactDiv = impactDivs;
          let actionOrientedIds = {}
          Object.entries(impactResultsArray).forEach(([divId, divObj]) => {
            const detections = divObj.action_oriented?.detection || [];
            if(detections.length !== 0) {
              actionOrientedIds[divId] = detections.map(det => ({
                word: det.word,
                strength: det.strength?.status || null
              }));
            }
          });
          if(!_.isEmpty(actionOrientedIds) &&
            impact['action_oriented'] && impact['action_oriented'][0] != null)
          {
            impact['action_oriented'][0] = ({
              ids: actionOrientedIds,
              pos_present: true,
              color:
                sectionFeedback['overall_impact_score_class'][
                  'active_score_color_feedback'
                ],
              score: lowerScore(
                sectionFeedback['overall_impact_score_class'][
                  'overall_active_score'
                ]
              ),
            })
            impact['action_oriented_color'][0] = ({
              color:
                sectionFeedback['overall_impact_score_class'][
                  'active_score_color_feedback'
                ],
              score: lowerScore(
                sectionFeedback['overall_impact_score_class'][
                  'overall_active_score'
                ]
              ),
            })
          }
          let specificsIds = {}
          if (!_.isEmpty(impactDiv.bullet_divs)) {
            Object.entries(impactDiv.bullet_divs).forEach(([divId, divObj]) => {
              if(divObj.specifics_divs && divObj.specifics_divs.div_ids) {
                divObj.specifics_divs.div_ids.forEach(divInfo => {
                  if (divInfo && Array.isArray(divInfo.word)) {
                    specificsIds[divInfo.div_id] = divInfo.word.map(wordObj => ({
                      word: wordObj.keyword,
                      pos: wordObj.position,
                    }));
                  }
                })
              }
            })
          }
          if (!_.isEmpty(impactDiv.non_bullet_divs)) {
            Object.entries(impactDiv.non_bullet_divs).forEach(([divId, divObj]) => {
              if(divObj.specifics_divs && divObj.specifics_divs.div_ids) {
                divObj.specifics_divs.div_ids.forEach(divInfo => {
                  if (divInfo && Array.isArray(divInfo.word)) {
                    specificsIds[divInfo.div_id] = divInfo.word.map(wordObj => ({
                      word: wordObj.keyword,
                      pos: wordObj.position,
                    }));
                  }
                })
              }
            })
          }
          if(!_.isEmpty(specificsIds) && 
            impact['specifics'] && impact['specifics'][0] != null
          )
          {
            impact['specifics'][0] = ({
              ids: specificsIds,
              pos_present: true,
              color:
                sectionFeedback['overall_impact_score_class'][
                  'specifics_score_color_feedback'
                ],
              score: lowerScore(
                sectionFeedback['overall_impact_score_class'][
                  'overall_specifics_score'
                ]
              ),
            })
            impact['specifics_color'][0] = ({
              color:
                sectionFeedback['overall_impact_score_class'][
                  'specifics_score_color_feedback'
                ],
              score: lowerScore(
                sectionFeedback['overall_impact_score_class'][
                  'overall_specifics_score'
                ]
              ),
            })
          }
        }
      }
    }

    return impact
  }

  getImpactEntities(sectionImpact, entityMapEditable) {
    const { isGenAiFeedback } = this.props
    if (_.isNull(sectionImpact)) {
      return null
    }
    let impactEntities = {}
    let subModules = ['action_oriented', 'specifics']
    if (sectionImpact.hasOwnProperty('action_oriented')) {
      impactEntities['action_oriented'] = {}
      for (var sectionIndex in sectionImpact['action_oriented']) {
        var obj = {
          color:
            sectionImpact['action_oriented' + '_color'][sectionIndex]['color'],
          text: [],
        }
        for (var divId in sectionImpact['action_oriented'][sectionIndex][
          'ids'
        ]) {
          var entities = entityMapEditable[divId]
          for (var j in sectionImpact['action_oriented'][sectionIndex]['ids'][
            divId
          ]) {
            if ( isGenAiFeedback ) {
              for (var k in entities) {
                obj['text'].push({
                  entity: entities[k][2],
                  text: sectionImpact['action_oriented'][sectionIndex]['ids'][divId][j][
                    'word'
                  ],
                  color: sectionImpact['action_oriented'][sectionIndex]['ids'][divId][j][
                    'strength'
                  ] === 'weak'
                  ? 'red' 
                  : 'green',
                })
              }
            } else {
              for (var k in entities) {
                obj['text'].push({
                  entity: entities[k][2],
                  text: entities[k][3],
                  word: sectionImpact['action_oriented'][sectionIndex]['ids'][
                    divId
                  ][j]['word'],
                })
              }
            }
          }
        }
        impactEntities['action_oriented'][sectionIndex] = obj
      }
    }
    if (sectionImpact.hasOwnProperty('specifics')) {
      impactEntities['specifics'] = {}
      for (var sectionIndex in sectionImpact['specifics']) {
        var obj = {
          color: sectionImpact['specifics' + '_color'][sectionIndex]['color'],
          text: [],
        }
        for (var divId in sectionImpact['specifics'][sectionIndex]['ids']) {
          var entities = entityMapEditable[divId]
          for (var j in sectionImpact['specifics'][sectionIndex]['ids'][
            divId
          ]) {
            for (var k in entities) {
              obj['text'].push({
                entity: entities[k][2],
                text: sectionImpact['specifics'][sectionIndex]['ids'][divId][j][
                  'word'
                ],
              })
            }
          }
        }
        impactEntities['specifics'][sectionIndex] = obj
      }
    }

    return impactEntities
  }

  getCategories(sectionFeedback, isExperience) {
    const { isUKEnable = false } = this.props
    let categories = {}
    if (!_.isUndefined(sectionFeedback['overall_category_score_class'])) {
      categories['score'] = []
      if (
        _.isUndefined(
          sectionFeedback['overall_category_score_class']['sub_section']
        )
      ) {
        categories['score'].push({
          color:
            sectionFeedback['overall_category_score_class']['color_feedback'],
          score: lowerScore(
            sectionFeedback['overall_category_score_class'][
              'overall_category_score'
            ]
          ),
        })
      } else {
        for (var i in sectionFeedback['overall_category_score_class'][
          'sub_section'
        ]) {
          categories['score'].push({
            color:
              sectionFeedback['overall_category_score_class']['sub_section'][i][
                'color_feedback'
              ],
            score: lowerScore(
              sectionFeedback['overall_category_score_class']['sub_section'][i][
                'overall_category_score'
              ]
            ),
          })
        }
      }
    }
    if (!_.isUndefined(sectionFeedback['categories_present'])) {
      categories['categories'] = []
      let cleanCategory = ''
      if (!isExperience) {
        var temp = {}
        for (var divId in sectionFeedback['categories_present']) {
          for (var category in sectionFeedback['categories_present'][divId]) {
            cleanCategory = cleanWord(category, isUKEnable)
            if (!temp.hasOwnProperty(cleanCategory)) {
              temp[cleanCategory] = { ids: {}, pos_present: false }
            }
            if (!temp[cleanCategory].hasOwnProperty(divId)) {
              temp[cleanCategory]['ids'][divId] = []
            }
            for (var index in sectionFeedback['categories_present'][divId][
              category
            ]) {
              if (
                _.isObject(
                  sectionFeedback['categories_present'][divId][category][index]
                ) ||
                _.isArray(
                  sectionFeedback['categories_present'][divId][category][index]
                )
              ) {
                if (
                  !_.isNull(
                    sectionFeedback['categories_present'][divId][category][
                      index
                    ]['positions']
                  )
                ) {
                  for (var posIndex in sectionFeedback['categories_present'][
                    divId
                  ][category][index]['positions']) {
                    temp[cleanCategory]['ids'][divId].push({
                      word: sectionFeedback['categories_present'][divId][
                        category
                      ][index]['keyword'],
                      pos: sectionFeedback['categories_present'][divId][
                        category
                      ][index]['positions'][posIndex],
                    })
                  }
                  temp[cleanCategory]['pos_present'] = true
                } else {
                  temp[cleanCategory]['ids'][divId].push({
                    word: sectionFeedback['categories_present'][divId][
                      category
                    ][index]['keyword'],
                  })
                }
              } else {
                temp[cleanCategory]['ids'][divId].push({
                  word: sectionFeedback['categories_present'][divId][category][
                    index
                  ],
                })
              }
            }
          }
        }
        categories['categories'].push(temp)
      } else {
        for (var i in sectionFeedback['categories_present']) {
          var temp = {}
          for (var divId in sectionFeedback['categories_present'][i]) {
            for (var category in sectionFeedback['categories_present'][i][
              divId
            ]) {
              cleanCategory = cleanWord(category, isUKEnable)
              if (!temp.hasOwnProperty(cleanCategory)) {
                temp[cleanCategory] = { ids: {}, pos_present: false }
              }
              if (!temp[cleanCategory].hasOwnProperty(divId)) {
                temp[cleanCategory]['ids'][divId] = []
              }
              for (var index in sectionFeedback['categories_present'][i][divId][
                category
              ]) {
                if (
                  _.isObject(
                    sectionFeedback['categories_present'][i][divId][category][
                      index
                    ]
                  ) ||
                  _.isArray(
                    sectionFeedback['categories_present'][i][divId][category][
                      index
                    ]
                  )
                ) {
                  if (
                    !_.isNull(
                      sectionFeedback['categories_present'][i][divId][category][
                        index
                      ]['positions']
                    )
                  ) {
                    for (var posIndex in sectionFeedback['categories_present'][
                      i
                    ][divId][category][index]['positions']) {
                      temp[cleanCategory]['ids'][divId].push({
                        word: sectionFeedback['categories_present'][i][divId][
                          category
                        ][index]['keyword'],
                        pos: sectionFeedback['categories_present'][i][divId][
                          category
                        ][index]['positions'][posIndex],
                      })
                    }
                    temp[cleanCategory]['pos_present'] = true
                  } else {
                    temp[cleanCategory]['ids'][divId].push({
                      word: sectionFeedback['categories_present'][i][divId][
                        category
                      ][index]['keyword'],
                    })
                  }
                } else {
                  temp[cleanCategory]['ids'][divId].push({
                    word: sectionFeedback['categories_present'][i][divId][
                      category
                    ][index],
                  })
                }
              }
            }
          }
          categories['categories'].push(temp)
        }
      }
    }

    return categories
  }

  getCategoriesMissing(sectionCategories2) {
    const { isUKEnable = false } = this.props
    let sectionCategories = [].concat(sectionCategories2)
    let temp = []
    for (let i in sectionCategories) {
      temp[i] = []
      for (let j in sectionCategories[i]) {
        temp[i].push(cleanWord(j, isUKEnable))
      }
    }
    return temp
  }

  getCategoriesInResumeNotInLinkedin(sectionFeedback, sectionName) {
    const { isUKEnable = false } = this.props
    let temp = []

    if (sectionName == 'Summary' || sectionName == 'Headline') {
      if (
        !_.isUndefined(sectionFeedback) &&
        sectionFeedback.hasOwnProperty(
          'categories_in_resume_not_in_linkedin'
        ) &&
        !_.isEmpty(sectionFeedback['categories_in_resume_not_in_linkedin'])
      ) {
        temp[0] = []
        for (let i in sectionFeedback['categories_in_resume_not_in_linkedin']) {
          temp[0].push(
            cleanWord(
              sectionFeedback['categories_in_resume_not_in_linkedin'][i],
              isUKEnable
            )
          )
        }
        return temp
      }
    }

    if (sectionName == 'Experience' || sectionName == 'Education') {
      if (
        !_.isUndefined(sectionFeedback) &&
        sectionFeedback.hasOwnProperty(
          'categories_in_resume_not_in_linkedin'
        ) &&
        !_.isEmpty(sectionFeedback['categories_in_resume_not_in_linkedin'])
      ) {
        for (
          let j = 0;
          j < sectionFeedback['categories_in_resume_not_in_linkedin'].length;
          j++
        ) {
          temp[j] = []
          for (let i in sectionFeedback['categories_in_resume_not_in_linkedin'][
            j
          ]) {
            temp[j].push(
              cleanWord(
                sectionFeedback['categories_in_resume_not_in_linkedin'][j][i],
                isUKEnable
              )
            )
          }
        }
        return temp
      }
    }
    return temp
  }

  getCategoriesEntities(sectionCategories, entityMapEditable) {
    let categoriesEntities = {}
    for (let sectionIndex in sectionCategories['categories']) {
      categoriesEntities[sectionIndex] = {}
      for (let subModule in sectionCategories['categories'][sectionIndex]) {
        let obj = { color: 'green', text: [] }
        for (let divId in sectionCategories['categories'][sectionIndex][
          subModule
        ]['ids']) {
          let entities = entityMapEditable[divId]
          for (let j in sectionCategories['categories'][sectionIndex][
            subModule
          ]['ids'][divId]) {
            for (let k in entities) {
              obj['text'].push({
                entity: entities[k][2],
                text: sectionCategories['categories'][sectionIndex][subModule][
                  'ids'
                ][divId][j]['word'],
              })
            }
          }
        }
        categoriesEntities[sectionIndex][subModule] = obj
      }
    }

    return categoriesEntities
  }

  getSkills(sectionFeedback, skillTypes = []) {
    const { isUKEnable = false } = this.props
    let skills = {}
    if (!_.isUndefined(sectionFeedback['overall_skills_score_class'])) {
      skills['score'] = []
      if (
        _.isUndefined(
          sectionFeedback['overall_skills_score_class']['overall_score_class'][
            'sub_section'
          ]
        )
      ) {
        skills['score'].push({
          color:
            sectionFeedback['overall_skills_score_class'][
              'overall_score_class'
            ]['color_feedback'],
          score: lowerScore(
            sectionFeedback['overall_skills_score_class'][
              'overall_score_class'
            ]['overall_score']
          ),
        })
      } else {
        for (var i in sectionFeedback['overall_skills_score_class'][
          'overall_score_class'
        ]['sub_section']) {
          skills['score'].push({
            color:
              sectionFeedback['overall_skills_score_class'][
                'overall_score_class'
              ]['sub_section'][i]['overall_score_class']['color_feedback'],
            score: lowerScore(
              sectionFeedback['overall_skills_score_class'][
                'overall_score_class'
              ]['sub_section'][i]['overall_score_class']['overall_score']
            ),
          })
        }
      }
    }
    if (!_.isUndefined(sectionFeedback['relevant_skills_present'])) {
      skills['relevant_skills_present'] = []
      const types = ['hard_skills', 'sub_competency']
      let cleanSkill = ''
      if (
        sectionFeedback['relevant_skills_present'].hasOwnProperty('hard_skills')
      ) {
        var temp = {}
        for (var j in types) {
          var type = types[j]
          if (!_.isEmpty(skillTypes) && !_.contains(skillTypes, type)) {
            continue
          }
          for (var skill in sectionFeedback['relevant_skills_present'][type]) {
            cleanSkill = cleanWord(
              sectionFeedback['relevant_skills_present'][type][skill][
                'display_name'
              ],
              isUKEnable,
              sectionFeedback['relevant_skills_present'][type][skill][
                'is_display_name_set'
              ]
            )
            if (!temp.hasOwnProperty(cleanSkill)) {
              temp[cleanSkill] = []
            }
            if (!this.derivedSkills.hasOwnProperty(cleanSkill)) {
              this.derivedSkills[cleanSkill] = false
            }
            for (var divId in sectionFeedback['relevant_skills_present'][type][
              skill
            ]['keyword']) {
              var phrases = []
              var text =
                sectionFeedback['text_array'][divId]['text'].toLowerCase()
              for (var verb in sectionFeedback['relevant_skills_present'][type][
                skill
              ]['keyword'][divId]) {
                var vp = text.indexOf(verb)
                if (vp === -1) {
                  continue
                }
                for (var nounIndex in sectionFeedback[
                  'relevant_skills_present'
                ][type][skill]['keyword'][divId][verb]) {
                  var noun =
                    sectionFeedback['relevant_skills_present'][type][skill][
                      'keyword'
                    ][divId][verb][nounIndex]
                  var np = text.indexOf(noun)
                  if (np === -1 || np <= vp) {
                    continue
                  }
                  np += noun.length
                  phrases.push(text.substr(vp, np - vp))
                }
              }

              temp[cleanSkill].push({
                id: divId,
                type: type,
                state: 'derived',
                frequency:
                  sectionFeedback['relevant_skills_present'][type][skill][
                    'frequency'
                  ],
                score:
                  sectionFeedback['relevant_skills_present'][type][skill][
                    'score'
                  ],
                phrases: _.uniq(phrases),
              })
              this.derivedSkills[cleanSkill] = true
            }
            if (
              sectionFeedback['relevant_skills_present'][type][
                skill
              ].hasOwnProperty('stated_div_ids')
            ) {
              for (var index in sectionFeedback['relevant_skills_present'][
                type
              ][skill]['stated_div_ids']) {

                // new code to handle headline skills not highlighting issue
                let stated_actual_keyword = ''
                if (
                  sectionFeedback['relevant_skills_present'][type][
                    skill
                  ].hasOwnProperty('stated_actual_keyword')
                ) {
                  stated_actual_keyword =
                    sectionFeedback['relevant_skills_present'][type][skill][
                      'stated_actual_keyword'
                    ]
                }
                temp[cleanSkill].push({
                  id: sectionFeedback['relevant_skills_present'][type][skill][
                    'stated_div_ids'
                  ][index],
                  type: type,
                  state: 'stated',
                  frequency:
                    sectionFeedback['relevant_skills_present'][type][skill][
                      'frequency'
                    ],
                  score:
                    sectionFeedback['relevant_skills_present'][type][skill][
                      'score'
                    ],
                  stated_actual_keyword: stated_actual_keyword,
                })
              }
            }
          }
        }
        skills['relevant_skills_present'].push(temp)
      } else {
        let skillsPresentKeys = _.keys(
          sectionFeedback['relevant_skills_present']
        )
        let textKeys = _.keys(sectionFeedback['text_array'])
        for (let ii in skillsPresentKeys) {
          var i = skillsPresentKeys[ii]
          let textKey = textKeys[ii]
          var temp = []
          for (var j in types) {
            var type = types[j]
            if (!_.isEmpty(skillTypes) && !_.contains(skillTypes, type)) {
              continue
            }
            for (var skill in sectionFeedback['relevant_skills_present'][i][
              type
            ]) {
              cleanSkill = cleanWord(
                sectionFeedback['relevant_skills_present'][i][type][skill][
                  'display_name'
                ],
                isUKEnable,
                sectionFeedback['relevant_skills_present'][i][type][skill][
                  'is_display_name_set'
                ]
              )
              if (!temp.hasOwnProperty(cleanSkill)) {
                temp[cleanSkill] = []
              }
              if (!this.derivedSkills.hasOwnProperty(cleanSkill)) {
                this.derivedSkills[cleanSkill] = false
              }
              for (var divId in sectionFeedback['relevant_skills_present'][i][
                type
              ][skill]['keyword']) {
                var phrases = []
                if (
                  _.isUndefined(textKey) ||
                  _.isNull(textKey) ||
                  _.isUndefined(sectionFeedback['text_array'][textKey][divId])
                ) {
                  continue
                }
                var text =
                  sectionFeedback['text_array'][textKey][divId][
                    'text'
                  ].toLowerCase()
                for (var verb in sectionFeedback['relevant_skills_present'][i][
                  type
                ][skill]['keyword'][divId]) {
                  var vp = text.indexOf(verb)
                  if (vp === -1) {
                    continue
                  }
                  for (var nounIndex in sectionFeedback[
                    'relevant_skills_present'
                  ][i][type][skill]['keyword'][divId][verb]) {
                    var noun =
                      sectionFeedback['relevant_skills_present'][i][type][
                        skill
                      ]['keyword'][divId][verb][nounIndex]
                    var np = text.indexOf(noun)
                    if (np === -1 || np <= vp) {
                      continue
                    }
                    np += noun.length
                    phrases.push(text.substr(vp, np - vp))
                  }
                }

                temp[cleanSkill].push({
                  id: divId,
                  type: type,
                  state: 'derived',
                  frequency:
                    sectionFeedback['relevant_skills_present'][i][type][skill][
                      'frequency'
                    ],
                  score:
                    sectionFeedback['relevant_skills_present'][i][type][skill][
                      'score'
                    ],
                  phrases: _.uniq(phrases),
                })
                this.derivedSkills[cleanSkill] = true
              }
              if (
                sectionFeedback['relevant_skills_present'][i][type][
                  skill
                ].hasOwnProperty('stated_div_ids')
              ) {
                for (var index in sectionFeedback['relevant_skills_present'][i][
                  type
                ][skill]['stated_div_ids']) {
                  temp[cleanSkill].push({
                    id: sectionFeedback['relevant_skills_present'][i][type][
                      skill
                    ]['stated_div_ids'][index],
                    type: type,
                    state: 'stated',
                    frequency:
                      sectionFeedback['relevant_skills_present'][i][type][
                        skill
                      ]['frequency'],
                    score:
                      sectionFeedback['relevant_skills_present'][i][type][
                        skill
                      ]['score'],
                  })
                }
              }
            }
          }
          skills['relevant_skills_present'].push(temp)
        }
      }
    }
    if (!_.isUndefined(sectionFeedback['relevant_skills_missing'])) {
      skills['relevant_skills_missing'] = []
      const types = ['hard_skills', 'sub_competency']
      if (
        sectionFeedback['relevant_skills_missing'].hasOwnProperty('hard_skills')
      ) {
        var temp = []
        for (var j in types) {
          var type = types[j]
          if (!_.isEmpty(skillTypes) && !_.contains(skillTypes, type)) {
            continue
          }
          for (var skill in sectionFeedback['relevant_skills_missing'][type]) {
            if (
              sectionFeedback['relevant_skills_missing'][type][skill][
                'score'
              ] != 0
            ) {
              temp.push({
                word: cleanWord(
                  sectionFeedback['relevant_skills_missing'][type][skill][
                    'display_name'
                  ],
                  isUKEnable,
                  sectionFeedback['relevant_skills_missing'][type][skill][
                    'is_display_name_set'
                  ]
                ),
                type: type,
                score:
                  sectionFeedback['relevant_skills_missing'][type][skill][
                    'score'
                  ],
                frequency:
                  sectionFeedback['relevant_skills_missing'][type][skill][
                    'frequency'
                  ],
              })
            }
          }
        }
        skills['relevant_skills_missing'].push(temp)
      } else {
        for (var i in sectionFeedback['relevant_skills_missing']) {
          var temp = []
          for (var j in types) {
            var type = types[j]
            if (!_.isEmpty(skillTypes) && !_.contains(skillTypes, type)) {
              continue
            }
            for (var skill in sectionFeedback['relevant_skills_missing'][i][
              type
            ]) {
              if (
                sectionFeedback['relevant_skills_missing'][i][type][skill][
                  'score'
                ] != 0
              ) {
                temp.push({
                  word: cleanWord(
                    sectionFeedback['relevant_skills_missing'][i][type][skill][
                      'display_name'
                    ],
                    isUKEnable,
                    sectionFeedback['relevant_skills_missing'][i][type][skill][
                      'is_display_name_set'
                    ]
                  ),
                  type: type,
                  score:
                    sectionFeedback['relevant_skills_missing'][i][type][skill][
                      'score'
                    ],
                  frequency:
                    sectionFeedback['relevant_skills_missing'][i][type][skill][
                      'frequency'
                    ],
                })
              }
            }
          }
          skills['relevant_skills_missing'].push(temp)
        }
      }
    }

    if (!_.isUndefined(sectionFeedback['recommended_skills'])) {
      skills['recommended_skills'] = []
      const types = ['hard_skills', 'sub_competency']
      let temp = []
      for (let j in types) {
        let type = types[j]
        for (let skill in sectionFeedback['recommended_skills'][type]) {
          if (
            sectionFeedback['recommended_skills'][type][skill]['score'] !== 0
          ) {
            temp.push({
              word: cleanWord(
                sectionFeedback['recommended_skills'][type][skill][
                  'display_name'
                ],
                isUKEnable,
                sectionFeedback['recommended_skills'][type][skill][
                  'is_display_name_set'
                ]
              ),
              type: type,
              score:
                sectionFeedback['recommended_skills'][type][skill]['score'],
              frequency:
                sectionFeedback['recommended_skills'][type][skill]['frequency'],
            })
          }
        }
      }
      skills['recommended_skills'].push(temp)
    }

    return skills
  }

  getExperienceTitleHardSkills(sectionFeedback) {
    if (!sectionFeedback.hasOwnProperty('text_array')) {
      return []
    }

    let titleHardSkills = {}
    let topSkills = {}
    for (let subSectionId in sectionFeedback['text_array']) {
      titleHardSkills[subSectionId] = {}
      for (let divId in sectionFeedback['text_array'][subSectionId]) {
        if (
          sectionFeedback['text_array'][subSectionId][divId]['is_title'] == true
        ) {
          if (
            sectionFeedback.hasOwnProperty('relevant_skills_present') &&
            sectionFeedback['relevant_skills_present'].hasOwnProperty(
              subSectionId
            ) &&
            sectionFeedback['relevant_skills_present'][
              subSectionId
            ].hasOwnProperty('hard_skills')
          ) {
            for (var skill in sectionFeedback['relevant_skills_present'][
              subSectionId
            ]['hard_skills']) {
              if (
                sectionFeedback['relevant_skills_present'][subSectionId][
                  'hard_skills'
                ][skill].hasOwnProperty('keyword')
              ) {
                for (let id in sectionFeedback['relevant_skills_present'][
                  subSectionId
                ]['hard_skills'][skill]['keyword']) {
                  if (id == divId) {
                    titleHardSkills[subSectionId][skill] = 'derived'
                    break
                  }
                }
              }
              if (
                sectionFeedback['relevant_skills_present'][subSectionId][
                  'hard_skills'
                ][skill].hasOwnProperty('stated_div_ids')
              ) {
                for (var i in sectionFeedback['relevant_skills_present'][
                  subSectionId
                ]['hard_skills'][skill]['stated_div_ids']) {
                  if (
                    sectionFeedback['relevant_skills_present'][subSectionId][
                      'hard_skills'
                    ][skill]['stated_div_ids'][i] == divId
                  ) {
                    titleHardSkills[subSectionId][skill] = 'stated'
                    break
                  }
                }
              }
            }
          }

          // Only 1 divId is title
          break
        }
      }

      let allSkillsList = []
      if (
        sectionFeedback.hasOwnProperty('relevant_skills_present') &&
        sectionFeedback['relevant_skills_present'].hasOwnProperty(
          subSectionId
        ) &&
        sectionFeedback['relevant_skills_present'][subSectionId].hasOwnProperty(
          'hard_skills'
        )
      ) {
        for (var skill in sectionFeedback['relevant_skills_present'][
          subSectionId
        ]['hard_skills']) {
          var freq =
            -1 *
            parseInt(
              sectionFeedback['relevant_skills_present'][subSectionId][
                'hard_skills'
              ][skill]['frequency']
            )
          allSkillsList.push({ skill: skill, tag: 'present', frequency: freq })
        }
      }
      if (
        sectionFeedback.hasOwnProperty('relevant_skills_missing') &&
        sectionFeedback['relevant_skills_missing'].hasOwnProperty(
          subSectionId
        ) &&
        sectionFeedback['relevant_skills_missing'][subSectionId].hasOwnProperty(
          'hard_skills'
        )
      ) {
        for (var skill in sectionFeedback['relevant_skills_missing'][
          subSectionId
        ]['hard_skills']) {
          var freq =
            -1 *
            parseInt(
              sectionFeedback['relevant_skills_missing'][subSectionId][
                'hard_skills'
              ][skill]['frequency']
            )
          allSkillsList.push({ skill: skill, tag: 'missing', frequency: freq })
        }
      }
      _.sortBy(allSkillsList, 'frequency')
      topSkills[subSectionId] = {}
      let count = {
        count: { present: 0, missing: 0 },
        min_wanted: { present: 3, missing: 2 },
      }
      for (var i in allSkillsList) {
        if (
          count['min_wanted'][allSkillsList[i]['tag']] ==
          count['count'][allSkillsList[i]['tag']]
        ) {
          continue
        }
        topSkills[subSectionId][allSkillsList[i]['skill']] =
          allSkillsList[i]['frequency']
        count['count'][allSkillsList[i]['tag']]++
        if (count['count']['present'] + count['count']['missing'] == 5) {
          break
        }
      }
      if (count['count']['present'] + count['count']['missing'] < 5) {
        for (var i in allSkillsList) {
          if (
            topSkills[subSectionId].hasOwnProperty(allSkillsList[i]['skill'])
          ) {
            continue
          }
          topSkills[subSectionId][allSkillsList[i]['skill']] =
            allSkillsList[i]['frequency']
          count['count'][allSkillsList[i]['tag']]++
          if (count['count']['present'] + count['count']['missing'] == 5) {
            break
          }
        }
      }
      // Sort by frequency
      let sortable = []
      for (var skill in topSkills[subSectionId]) {
        sortable.push([skill, topSkills[subSectionId][skill]])
      }
      sortable.sort(function (a, b) {
        return a[1] - b[1]
      })
      topSkills[subSectionId] = _.map(sortable, function (v) {
        return v[0]
      })
    }

    return { present_skills: titleHardSkills, top_skills: topSkills }
  }

  getSkillsEntities(sectionSkills, entityMapEditable) {
    let skillsEntities = {
      relevant_skills_present: {},
      relevant_skills_missing: {},
    }
    for (var sectionIndex in sectionSkills['relevant_skills_present']) {
      skillsEntities['relevant_skills_present'][sectionIndex] = {}
      for (let skill in sectionSkills['relevant_skills_present'][
        sectionIndex
      ]) {
        let obj = []
        for (var j in sectionSkills['relevant_skills_present'][sectionIndex][
          skill
        ]) {
          let entities =
            entityMapEditable[
              sectionSkills['relevant_skills_present'][sectionIndex][skill][j][
                'id'
              ]
            ]
          for (let k in entities) {
            obj.push({ entity: entities[k][2], text: entities[k][3] })
          }
        }
        skillsEntities['relevant_skills_present'][sectionIndex][skill] = obj
      }
    }
    for (var sectionIndex in sectionSkills['relevant_skills_missing']) {
      skillsEntities['relevant_skills_missing'][sectionIndex] = []
      for (var j in sectionSkills['relevant_skills_missing'][sectionIndex]) {
        skillsEntities['relevant_skills_missing'][sectionIndex].push(
          sectionSkills['relevant_skills_missing'][sectionIndex][j]['word']
        )
      }
    }

    return skillsEntities
  }

  getSeo(sectionFeedback, isExperience) {
    const { isUKEnable = false } = this.props
    let seo = {}
    if (
      !_.isUndefined(sectionFeedback['overall_profile_visibility_score_class'])
    ) {
      seo['score'] = []
      if (
        _.isUndefined(
          sectionFeedback['overall_profile_visibility_score_class'][
            'sub_section'
          ]
        )
      ) {
        seo['score'].push({
          color:
            sectionFeedback['overall_profile_visibility_score_class'][
              'color_feedback'
            ],
          score: lowerScore(
            sectionFeedback['overall_profile_visibility_score_class'][
              'overall_profile_visibility_score'
            ]
          ),
        })
      } else {
        for (var i in sectionFeedback['overall_profile_visibility_score_class'][
          'sub_section'
        ]) {
          seo['score'].push({
            color:
              sectionFeedback['overall_profile_visibility_score_class'][
                'sub_section'
              ][i]['color_feedback'],
            score: lowerScore(
              sectionFeedback['overall_profile_visibility_score_class'][
                'sub_section'
              ][i]['overall_profile_visibility_score']
            ),
          })
        }
      }
    }

    seo['keywords'] = []
    let seoWord = ''
    if (!isExperience) {
      var temp = { relevant: {}, irrelevant: {} }
      if (!_.isUndefined(sectionFeedback['seo_relevant_keywords'])) {
        for (var index in sectionFeedback['seo_relevant_keywords'][
          'hard_skills'
        ]) {
          for (var divId in sectionFeedback['seo_relevant_keywords'][
            'hard_skills'
          ][index]['derived_noun_positions']) {
            for (var verb in sectionFeedback['seo_relevant_keywords'][
              'hard_skills'
            ][index]['derived_noun_positions'][divId]) {
              for (var rid in sectionFeedback['seo_relevant_keywords'][
                'hard_skills'
              ][index]['derived_noun_positions'][divId][verb]) {
                var nounWord = cleanWord(
                  sectionFeedback['seo_relevant_keywords']['hard_skills'][
                    index
                  ]['derived_noun_positions'][divId][verb][rid]['noun'],
                  isUKEnable,
                  sectionFeedback['seo_relevant_keywords']['hard_skills'][
                    index
                  ]['derived_noun_positions'][divId][verb][rid][
                    'is_display_name_set'
                  ]
                )
                if (!temp['relevant'].hasOwnProperty(nounWord)) {
                  temp['relevant'][nounWord] = []
                }
                for (var posIndex in sectionFeedback['seo_relevant_keywords'][
                  'hard_skills'
                ][index]['derived_noun_positions'][divId][verb][rid][
                  'positions'
                ]) {
                  temp['relevant'][nounWord].push({
                    id: divId,
                    pos: sectionFeedback['seo_relevant_keywords'][
                      'hard_skills'
                    ][index]['derived_noun_positions'][divId][verb][rid][
                      'positions'
                    ][posIndex],
                  })
                }
              }
            }
          }
          if (
            _.size(
              sectionFeedback['seo_relevant_keywords']['hard_skills'][index][
                'stated_skills_positions'
              ]
            ) > 0
          ) {
            var nounWord = cleanWord(
              sectionFeedback['seo_relevant_keywords']['hard_skills'][index][
                'display_name'
              ],
              isUKEnable,
              sectionFeedback['seo_relevant_keywords']['hard_skills'][index][
                'is_display_name_set'
              ]
            )
            if (!temp['relevant'].hasOwnProperty(nounWord)) {
              temp['relevant'][nounWord] = []
            }
            for (var divId in sectionFeedback['seo_relevant_keywords'][
              'hard_skills'
            ][index]['stated_skills_positions']) {
              for (var posIndex in sectionFeedback['seo_relevant_keywords'][
                'hard_skills'
              ][index]['stated_skills_positions'][divId]) {
                temp['relevant'][nounWord].push({
                  id: divId,
                  pos: sectionFeedback['seo_relevant_keywords']['hard_skills'][
                    index
                  ]['stated_skills_positions'][divId][posIndex],
                })
              }
            }
          }
        }
        for (var divId in sectionFeedback['seo_relevant_keywords'][
          'category_keywords'
        ]) {
          for (var index in sectionFeedback['seo_relevant_keywords'][
            'category_keywords'
          ][divId]) {
            var nounWord = cleanWord(
              sectionFeedback['seo_relevant_keywords']['category_keywords'][
                divId
              ][index]['display_name'],
              isUKEnable,
              sectionFeedback['seo_relevant_keywords']['category_keywords'][
                divId
              ][index]['is_display_name_set']
            )
            if (!temp['relevant'].hasOwnProperty(nounWord)) {
              temp['relevant'][nounWord] = []
            }
            for (var posIndex in sectionFeedback['seo_relevant_keywords'][
              'category_keywords'
            ][divId][index]['positions']) {
              temp['relevant'][nounWord].push({
                id: divId,
                pos: sectionFeedback['seo_relevant_keywords'][
                  'category_keywords'
                ][divId][index]['positions'][posIndex],
              })
            }
          }
        }
      }

      if (!_.isUndefined(sectionFeedback['seo_irrelevant_keywords'])) {
        for (var index in sectionFeedback['seo_irrelevant_keywords'][
          'hard_skills'
        ]) {
          var skillWord = cleanWord(
            sectionFeedback['seo_irrelevant_keywords']['hard_skills'][index][
              'display_name'
            ],
            isUKEnable,
            sectionFeedback['seo_irrelevant_keywords']['hard_skills'][index][
              'is_display_name_set'
            ]
          )
          if (!temp['irrelevant'].hasOwnProperty(skillWord)) {
            temp['irrelevant'][skillWord] = []
          }
          for (var divId in sectionFeedback['seo_irrelevant_keywords'][
            'hard_skills'
          ][index]['derived_keywords']) {
            temp['irrelevant'][skillWord].push(divId)
          }
          if (
            _.size(
              sectionFeedback['seo_irrelevant_keywords']['hard_skills'][index][
                'stated_div_ids'
              ]
            ) > 0
          ) {
            for (var divIndex in sectionFeedback['seo_irrelevant_keywords'][
              'hard_skills'
            ][index]['stated_div_ids']) {
              temp['irrelevant'][skillWord].push(
                sectionFeedback['seo_irrelevant_keywords']['hard_skills'][
                  index
                ]['stated_div_ids'][divIndex]
              )
            }
          }
        }
        for (var divId in sectionFeedback['seo_irrelevant_keywords'][
          'category_keywords'
        ]) {
          for (var index in sectionFeedback['seo_irrelevant_keywords'][
            'category_keywords'
          ][divId]) {
            var nounWord = cleanWord(
              sectionFeedback['seo_irrelevant_keywords']['category_keywords'][
                divId
              ][index]['display_name'],
              isUKEnable,
              sectionFeedback['seo_irrelevant_keywords']['category_keywords'][
                divId
              ][index]['is_display_name_set']
            )
            if (!temp['irrelevant'].hasOwnProperty(nounWord)) {
              temp['irrelevant'][nounWord] = []
            }
            temp['irrelevant'][nounWord].push(divId)
          }
        }
      }
      temp['new_irrelevant'] = []
      if (
        !_.isUndefined(sectionFeedback['seo_new_section_irrelevant_keywords'])
      ) {
        let newSectionIrrelevantKeywords =
          sectionFeedback['seo_new_section_irrelevant_keywords']
        if (!_.isUndefined(newSectionIrrelevantKeywords['new'])) {
          let newIrrelevant = newSectionIrrelevantKeywords['new']['hard_skills']
          temp['new_irrelevant'] = this.getCleanNewIrrelevant(
            newIrrelevant,
            temp['new_irrelevant'],
            isUKEnable
          )
        }
        if (!_.isUndefined(newSectionIrrelevantKeywords['category_keywords'])) {
          let newIrrelevant = newSectionIrrelevantKeywords['category_keywords']
          temp['new_irrelevant'] = this.getCleanNewIrrelevant(
            newIrrelevant,
            temp['new_irrelevant'],
            isUKEnable
          )
        }
      }
      seo['keywords'].push(temp)
    } else {
      for (var i in sectionFeedback['seo_relevant_keywords']) {
        var temp = { relevant: {}, irrelevant: {} }
        for (var index in sectionFeedback['seo_relevant_keywords'][i][
          'hard_skills'
        ]) {
          for (var divId in sectionFeedback['seo_relevant_keywords'][i][
            'hard_skills'
          ][index]['derived_noun_positions']) {
            for (var verb in sectionFeedback['seo_relevant_keywords'][i][
              'hard_skills'
            ][index]['derived_noun_positions'][divId]) {
              for (var rid in sectionFeedback['seo_relevant_keywords'][i][
                'hard_skills'
              ][index]['derived_noun_positions'][divId][verb]) {
                var nounWord = cleanWord(
                  sectionFeedback['seo_relevant_keywords'][i]['hard_skills'][
                    index
                  ]['derived_noun_positions'][divId][verb][rid]['display_name'],
                  isUKEnable,
                  sectionFeedback['seo_relevant_keywords'][i]['hard_skills'][
                    index
                  ]['derived_noun_positions'][divId][verb][rid][
                    'is_display_name_set'
                  ]
                )
                if (!temp['relevant'].hasOwnProperty(nounWord)) {
                  temp['relevant'][nounWord] = []
                }
                for (var posIndex in sectionFeedback['seo_relevant_keywords'][
                  i
                ]['hard_skills'][index]['derived_noun_positions'][divId][verb][
                  rid
                ]['positions']) {
                  temp['relevant'][nounWord].push({
                    id: divId,
                    pos: sectionFeedback['seo_relevant_keywords'][i][
                      'hard_skills'
                    ][index]['derived_noun_positions'][divId][verb][rid][
                      'positions'
                    ][posIndex],
                  })
                }
              }
            }
          }
          if (
            _.size(
              sectionFeedback['seo_relevant_keywords'][i]['hard_skills'][index][
                'stated_skills_positions'
              ]
            ) > 0
          ) {
            var nounWord = cleanWord(
              sectionFeedback['seo_relevant_keywords'][i]['hard_skills'][index][
                'display_name'
              ],
              isUKEnable,
              sectionFeedback['seo_relevant_keywords'][i]['hard_skills'][index][
                'is_display_name_set'
              ]
            )
            if (!temp['relevant'].hasOwnProperty(nounWord)) {
              temp['relevant'][nounWord] = []
            }
            for (var divId in sectionFeedback['seo_relevant_keywords'][i][
              'hard_skills'
            ][index]['stated_skills_positions']) {
              for (var posIndex in sectionFeedback['seo_relevant_keywords'][i][
                'hard_skills'
              ][index]['stated_skills_positions'][divId]) {
                temp['relevant'][nounWord].push({
                  id: divId,
                  pos: sectionFeedback['seo_relevant_keywords'][i][
                    'hard_skills'
                  ][index]['stated_skills_positions'][divId][posIndex],
                })
              }
            }
          }
        }
        for (var divId in sectionFeedback['seo_relevant_keywords'][i][
          'category_keywords'
        ]) {
          for (var index in sectionFeedback['seo_relevant_keywords'][i][
            'category_keywords'
          ][divId]) {
            var nounWord = cleanWord(
              sectionFeedback['seo_relevant_keywords'][i]['category_keywords'][
                divId
              ][index]['display_name'],
              isUKEnable,
              sectionFeedback['seo_relevant_keywords'][i]['category_keywords'][
                divId
              ][index]['is_display_name_set']
            )
            if (!temp['relevant'].hasOwnProperty(nounWord)) {
              temp['relevant'][nounWord] = []
            }
            for (var posIndex in sectionFeedback['seo_relevant_keywords'][i][
              'category_keywords'
            ][divId][index]['positions']) {
              temp['relevant'][nounWord].push({
                id: divId,
                pos: sectionFeedback['seo_relevant_keywords'][i][
                  'category_keywords'
                ][divId][index]['positions'][posIndex],
              })
            }
          }
        }
        if (!_.isUndefined(sectionFeedback['seo_irrelevant_keywords'])) {
          for (var index in sectionFeedback['seo_irrelevant_keywords'][i][
            'hard_skills'
          ]) {
            var skillWord = cleanWord(
              sectionFeedback['seo_irrelevant_keywords'][i]['hard_skills'][
                index
              ]['display_name'],
              isUKEnable,
              sectionFeedback['seo_irrelevant_keywords'][i]['hard_skills'][
                index
              ]['is_display_name_set']
            )
            if (!temp['irrelevant'].hasOwnProperty(skillWord)) {
              temp['irrelevant'][skillWord] = []
            }
            for (var divId in sectionFeedback['seo_irrelevant_keywords'][i][
              'hard_skills'
            ][index]['derived_keywords']) {
              temp['irrelevant'][skillWord].push(divId)
            }
            if (
              _.size(
                sectionFeedback['seo_irrelevant_keywords'][i]['hard_skills'][
                  index
                ]['stated_div_ids']
              ) > 0
            ) {
              for (var divIndex in sectionFeedback['seo_irrelevant_keywords'][
                i
              ]['hard_skills'][index]['stated_div_ids']) {
                temp['irrelevant'][skillWord].push(
                  sectionFeedback['seo_irrelevant_keywords'][i]['hard_skills'][
                    index
                  ]['stated_div_ids'][divIndex]
                )
              }
            }
          }
          for (var divId in sectionFeedback['seo_irrelevant_keywords'][i][
            'category_keywords'
          ]) {
            for (var index in sectionFeedback['seo_irrelevant_keywords'][i][
              'category_keywords'
            ][divId]) {
              var nounWord = cleanWord(
                sectionFeedback['seo_irrelevant_keywords'][i][
                  'category_keywords'
                ][divId][index]['display_name'],
                isUKEnable,
                sectionFeedback['seo_irrelevant_keywords'][i][
                  'category_keywords'
                ][divId][index]['is_display_name_set']
              )
              if (!temp['irrelevant'].hasOwnProperty(nounWord)) {
                temp['irrelevant'][nounWord] = []
              }
              temp['irrelevant'][nounWord].push(divId)
            }
          }
        }

        temp['new_irrelevant'] = []
        if (
          !_.isUndefined(sectionFeedback['seo_new_section_irrelevant_keywords'])
        ) {
          let newSectionIrrelevantKeywords =
            sectionFeedback['seo_new_section_irrelevant_keywords']
          if (!_.isUndefined(newSectionIrrelevantKeywords['new'])) {
            let newIrrelevant =
              newSectionIrrelevantKeywords['new']['hard_skills']
            temp['new_irrelevant'] = this.getCleanNewIrrelevant(
              newIrrelevant,
              temp['new_irrelevant'],
              isUKEnable
            )
          }
          if (
            !_.isUndefined(newSectionIrrelevantKeywords['category_keywords'])
          ) {
            let newIrrelevant =
              newSectionIrrelevantKeywords['category_keywords']
            temp['new_irrelevant'] = this.getCleanNewIrrelevant(
              newIrrelevant,
              temp['new_irrelevant'],
              isUKEnable
            )
          }
        }
        seo['keywords'].push(temp)
      }
      if (_.isUndefined(sectionFeedback['seo_relevant_keywords'])) {
        let temp = []
        temp['new_irrelevant'] = []
        if (
          !_.isUndefined(sectionFeedback['seo_new_section_irrelevant_keywords'])
        ) {
          let newSectionIrrelevantKeywords =
            sectionFeedback['seo_new_section_irrelevant_keywords']
          if (!_.isUndefined(newSectionIrrelevantKeywords['new'])) {
            let newIrrelevant =
              newSectionIrrelevantKeywords['new']['hard_skills']
            temp['new_irrelevant'] = this.getCleanNewIrrelevant(
              newIrrelevant,
              temp['new_irrelevant'],
              isUKEnable
            )
          }
          if (
            !_.isUndefined(newSectionIrrelevantKeywords['category_keywords'])
          ) {
            let newIrrelevant =
              newSectionIrrelevantKeywords['category_keywords']
            temp['new_irrelevant'] = this.getCleanNewIrrelevant(
              newIrrelevant,
              temp['new_irrelevant'],
              isUKEnable
            )
          }
          seo['keywords'].push(temp)
        }
      }
    }
    return seo
  }

  getCleanNewIrrelevant(newIrrelevant, temp, isUKEnable) {
    for (var index in newIrrelevant) {
      var cleanedWord = cleanWord(
        newIrrelevant[index]['display_name'],
        isUKEnable,
        newIrrelevant[index]['is_display_name_set']
      )
      temp.push(cleanedWord)
    }
    return temp
  }

  getSeoEntities(sectionSeo, entityMapEditable) {
    let seoEntities = { relevant: {}, irrelevant: {} }
    let types = ['relevant', 'irrelevant']
    for (let sectionIndex in sectionSeo['keywords']) {
      seoEntities['relevant'][sectionIndex] = {}
      for (var keyword in sectionSeo['keywords'][sectionIndex]['relevant']) {
        seoEntities['relevant'][sectionIndex][keyword] = []
        for (var j in sectionSeo['keywords'][sectionIndex]['relevant'][
          keyword
        ]) {
          var entities =
            entityMapEditable[
              sectionSeo['keywords'][sectionIndex]['relevant'][keyword][j]['id']
            ]
          for (var k in entities) {
            seoEntities['relevant'][sectionIndex][keyword].push({
              entity: entities[k][2],
              text: keyword,
            })
          }
        }
      }
      seoEntities['irrelevant'][sectionIndex] = {}
      for (var keyword in sectionSeo['keywords'][sectionIndex]['irrelevant']) {
        seoEntities['irrelevant'][sectionIndex][keyword] = []
        for (var j in sectionSeo['keywords'][sectionIndex]['irrelevant'][
          keyword
        ]) {
          var entities =
            entityMapEditable[
              sectionSeo['keywords'][sectionIndex]['irrelevant'][keyword][j]
            ]
          for (var k in entities) {
            seoEntities['irrelevant'][sectionIndex][keyword].push({
              entity: entities[k][2],
              text: keyword,
            })
          }
        }
      }
    }

    return seoEntities
  }

  mapToFrontEndName(targetJobFunctions) {
    for (let i in targetJobFunctions) {
      if (
        this.targetFunctionBackToFrontEndMapping.hasOwnProperty(
          targetJobFunctions[i]
        )
      ) {
        targetJobFunctions[i] =
          this.targetFunctionBackToFrontEndMapping[targetJobFunctions[i]]
      }
    }

    return targetJobFunctions
  }

  getRecommendedTitle(sectionFeedback) {
    const { isUKEnable } = this.props
    let output = []
    if (
      !sectionFeedback.hasOwnProperty('seo_recommended_keywords') ||
      _.isEmpty(sectionFeedback['seo_recommended_keywords'])
    ) {
      return output
    }
    let recomendedKeys = _.keys(sectionFeedback['seo_recommended_keywords'])
    let textKeys = _.keys(sectionFeedback['text_array'])
    for (let ki in recomendedKeys) {
      let i = recomendedKeys[ki]
      let j = textKeys[ki]

      let recommended = []
      for (let divId in sectionFeedback['seo_recommended_keywords'][i]) {
        let text = sectionFeedback['text_array'][j][divId]['text']
        let positionHash = []
        for (var index in sectionFeedback['seo_recommended_keywords'][i][
          divId
        ]) {
          let len =
            sectionFeedback['seo_recommended_keywords'][i][divId][index][
              'keyword'
            ].length
          for (let posIndex in sectionFeedback['seo_recommended_keywords'][i][
            divId
          ][index]['positions']) {
            positionHash.push({
              len: len,
              pos: sectionFeedback['seo_recommended_keywords'][i][divId][index][
                'positions'
              ][posIndex],
              replace:
                sectionFeedback['seo_recommended_keywords'][i][divId][index][
                  'recommended_keyword'
                ],
            })
          }
        }
        if (_.isEmpty(positionHash)) {
          continue
        }

        _.sortBy(positionHash, 'pos')
        positionHash = positionHash.reverse()

        for (var index in positionHash) {
          text =
            text.substr(0, positionHash[index]['pos']) +
            positionHash[index]['replace'] +
            text.substr(positionHash[index]['pos'] + positionHash[index]['len'])
        }

        let expr = new RegExp(' at ')

        if (expr.test(text)) {
          text = text.split(' at ')
          text.pop()
          text = text.join(' at ')
        }

        text = cleanWord(text, isUKEnable, false, false)

        recommended.push(text)
      }
      output.push(recommended)
    }
    return output
  }

  getExperienceDuration(cumulative, exp_count) {
    let output = []
    for (let i in cumulative) {
      output[cumulative[i]['sub_section_mapping']] =
        cumulative[i]['cumulative_experience_months']
    }

    if (_.isUndefined(exp_count)) return output

    for (let i = 0; i < exp_count['count']; i++) {
      if (_.isUndefined(output[i])) output[i] = 0
    }

    return output
  }

  getSectionsPerSkill(sections) {
    let sectionsPerSkill = {}
    for (let section in sections) {
      if (
        sections[section].hasOwnProperty('skills') &&
        sections[section]['skills'].hasOwnProperty('relevant_skills_present')
      ) {
        for (let sectionIndex in sections[section]['skills'][
          'relevant_skills_present'
        ]) {
          for (let skill in sections[section]['skills'][
            'relevant_skills_present'
          ][sectionIndex]) {
            if (!sectionsPerSkill.hasOwnProperty(skill)) {
              sectionsPerSkill[skill] = {
                sections: {},
                phrases: [],
                frequency: 0,
              }
            }
            if (!sectionsPerSkill[skill]['sections'].hasOwnProperty(section)) {
              sectionsPerSkill[skill]['sections'][section] = {}
            }
            sectionsPerSkill[skill]['sections'][section][sectionIndex] = []

            for (let i in sections[section]['skills'][
              'relevant_skills_present'
            ][sectionIndex][skill]) {
              let value =
                sections[section]['skills']['relevant_skills_present'][
                  sectionIndex
                ][skill][i]
              sectionsPerSkill[skill]['sections'][section][sectionIndex].push({
                id: value['id'],
                state: value['state'],
                type: value['type'],
              })
              sectionsPerSkill[skill]['frequency'] = value['frequency']

              for (let j in value['phrases']) {
                let phrase = value['phrases'][j]
                if (!_.isEmpty(phrase)) {
                  sectionsPerSkill[skill]['phrases'].push(phrase)
                }
              }
            }
          }
        }
      }
    }

    return sectionsPerSkill
  }

  getLogs() {
    const {
      logData,
      match: { params },
    } = this.props
    if (_.isEmpty(logData)) {
      return {}
    }
    let logs = {}
    const { fetchId } = params
    for (let section in logData) {
      logs[section] = {}
      for (let subSectionId in logData[section]) {
        logs[section][subSectionId] = []
        for (let i in logData[section][subSectionId]['logs']) {
          let data = logData[section][subSectionId]['logs'][i]['data']
          let uploadedAt =
            logData[section][subSectionId]['logs'][i]['uploaded_at']
          let change = 2
          if (
            logData[section][subSectionId]['logs'][i]['fetch_id'] == fetchId &&
            logData[section][subSectionId]['logs'][i].hasOwnProperty(
              'score_diff'
            )
          ) {
            let diff = parseFloat(
              logData[section][subSectionId]['logs'][i]['score_diff']
            )
            if (diff != 0) {
              change = diff < 0 ? -1 : 1
            } else {
              change = 0
            }
          }
          let renderText = this.getLogTextToRender(section, data)
          logs[section][subSectionId].push({
            data: data,
            date: uploadedAt,
            render_text: renderText,
            score_change: change,
            sub_section_uid: logData[section][subSectionId]['sub_section_uid'],
          })
        }
      }
    }
    return logs
  }

  getLogTextToRender(section, data) {
    if (section == 'Personal Information') {
      return data
    } else if (section == 'Profile Picture') {
      return data
    } else if (section == 'Headline') {
      return data['text']
    } else if (section == 'Summary') {
      return data['text']
    } else if (section == 'Experience') {
      let output = null
      if (!_.isEmpty(data['company'])) {
        output = {
          title: data['title'] + ' at ' + data['company'],
          sub_title: [''],
          text: '',
        }
      } else {
        output = { title: data['title'], sub_title: [''], text: '' }
      }

      if (!_.isEmpty(data['from'])) {
        output['sub_title'][0] += data['from']
        if (!_.isEmpty(data['to'])) {
          output['sub_title'][0] += ' - ' + data['to']
        }
      }
      if (!_.isEmpty(data['text'])) {
        output['text'] += data['text']
      }

      return output
    } else if (section == 'Education') {
      var output = { title: data['school'], sub_title: [], text: '' }
      if (!_.isEmpty(data['degree'])) {
        output['sub_title'].push(data['degree'])
      }
      if (!_.isEmpty(data['field_of_study'])) {
        output['sub_title'].push(data['field_of_study'])
      }
      let duration = ''
      if (!_.isEmpty(data['from'])) {
        duration += data['from'].toString()
        if (!_.isEmpty(data['to'])) {
          duration += ' - ' + data['to'].toString()
        }
      }
      if (!_.isEmpty(duration)) {
        output['sub_title'].push(duration)
      }
      if (!_.isEmpty(output['sub_title'])) {
        output['sub_title'] = [output['sub_title'].join(', ')]
      }
      if (!_.isEmpty(data['activities_and_societies'])) {
        output['text'] += data['activities_and_societies']
      }

      return output
    }
  }

  render() {
    const {
      location,
      ui,
      has_api,
      has_pdf,
      has_resume,
      status,
      resumeSkillsInLinkedin,
      resumeSkillsNotInLinkedin,
      match: { params },
      update_detailed_state,
      tourStatus,
      samples,
      allCapsResume,
      allSmallResume,
      normalResume,
      suggestedSkills,
      selectIndex,
    } = this.props // info, definitions, selectHighlightMessage
    const { fetchId } = params

    let navigation = null
    if (showNavigationPopup) {
      navigation = <ProductNavigation product="aspire" />
    }

    return (
      <div role="region" aria-labelledby="detailed-feedback">
        {navigation}
        <DetailedFeedbackComponent
          tabIndex={10}
          location={location}
          fetchId={fetchId}
          ui={ui}
          has_api={has_api}
          has_pdf={has_pdf}
          has_resume={has_resume}
          status={status}
          resumeSkillsInLinkedin={resumeSkillsInLinkedin}
          resumeSkillsNotInLinkedin={resumeSkillsNotInLinkedin}
          suggestedSkills={suggestedSkills}
          update_detailed_state={update_detailed_state}
          onSelectSection={this.onSelectSection}
          onSelectPrev={this.onSelectPrev}
          onSelectNext={this.onSelectNext}
          onSelectIndex={this.onSelectIndex}
          underlineSpellError={this.underlineSpellError}
          onUpdateText={this.onUpdateText}
          highlightEntityText={this.highlightEntityText}
          unhighlightAll={this.unhighlightAll}
          unhighlightAllEdit={this.unhighlightAllEdit}
          activeNavIndex={this.state.activeNavIndex}
          resetSectionNavs={this.resetSectionNavs}
          updateEditSection={this.updateEditSection}
          editSectionUpdated={this.editSectionUpdated}
          newSubSection={this.state.newSubSection}
          changeNewSubSectionValue={this.changeNewSubSectionValue}
          logModalMounted={this.logModalMounted}
          editModalMounted={this.editModalMounted}
          changeModalState={this.changeModalState}
          tourStatus={tourStatus}
          selectedPanelPersonalInfo={this.state.selectedPanelPersonalInfo}
          setSelectedPanelPersonalInfo={this.setSelectedPanelPersonalInfo}
          allCapsResume={allCapsResume}
          allSmallResume={allSmallResume}
          normalResume={normalResume}
          highlightableEditDivWords={this.highlightableEditDivWords}
        />
      </div>
    )
  }
}

function mapStateToProps(state, ownProps) {
  return {
    ui: state.detailedFeedbackUi, // ui state
    feedback: state.aspireFeedbackData.data, // aspire feedback data
    logData: state.aspireFeedbackData.logs,
    uploaded_picture: state.aspireFeedbackData.uploaded_picture,
    has_api: state.aspireFeedbackData.has_api,
    has_pdf: state.aspireFeedbackData.has_pdf,
    has_resume: state.aspireFeedbackData.has_resume,
    status: state.aspireFeedbackData.status,
    imageData: state.imageData,
    resumeSkillsInLinkedin: state.detailedFeedbackUi.resumeSkillsInLinkedin,
    suggestedSkills: state.detailedFeedbackUi.suggestedSkills,
    newSectionSuggestedSkills:
      state.detailedFeedbackUi.newSectionSuggestedSkills,
    resumeSkillsNotInLinkedin:
      state.detailedFeedbackUi.resumeSkillsNotInLinkedin,
    update_detailed_state: state.aspireFeedbackData.update_detailed_state,
    editedSection: state.editData.section_name,
    editedSubSectionId: state.editData.sub_section_id,
    editedIsNewSubSection: state.editData.new_sub_section,
    editedSectionDeleted: state.editData.delete_sub_section,
    tourStatus: state.tour.tourStatus,
    samples: state.aspireFeedbackData.samples,
    allCapsResume: state.aspireFeedbackData.allCapsResume,
    allSmallResume: state.aspireFeedbackData.allSmallResume,
    normalResume: state.aspireFeedbackData.normalResume,
    callOnSelectSectionDependenciesInDetailedFeedback:
      state.aspireFeedbackData
        .callOnSelectSectionDependenciesInDetailedFeedback,
    keyForSelectSection: state.aspireFeedbackData.keyForSelectSection,
    functions: state.aspireFunctionMappings.function_mappings,
    isUKEnable: state.aspireFeedbackData.ukEnglish,
    isEditModal: state.editData.show_edit_modal,
    dataSkills: state.aspireEditDynamicData.dataSkills,
    dataContent: state.aspireEditDynamicData.dataContent,
    dataLanguage: state.aspireEditDynamicData.dataLanguage,
    dataImpact: state.aspireEditDynamicData.dataImpact,
    dataRephraseWords: state.aspireEditDynamicData.dataRephraseWords,
    isGenAiFeedback: state.aspireFeedbackData.isGenAiFeedback,
  }
}

export default connect(mapStateToProps, {
  selectSection,
  selectIndex,
  updateText,
  detailedFeedbackUpdated,
  updateImageData,
  updateEditedDataState,
  redirectSelect,
  updateFeedbackState,
})(injectIntl(DetailedFeedback))